/* kc-product.js
 * Externalised from sections/kc-product.liquid to keep that template under
 * Shopify's 256KB byte cap. Behaviour-preserving move: the two inline
 * <script> blocks (main product JS + logo-addon JS) live here verbatim,
 * with their Liquid values supplied at runtime via window.kcPD (a tiny data
 * island rendered in the Liquid). Loaded with `defer`, so it runs after the
 * DOM is parsed and before DOMContentLoaded — preserving the original timing.
 */
(function () {
  var PD = window.kcPD || {};

document.addEventListener('DOMContentLoaded', function() {
  var variants = JSON.parse(document.getElementById('product-variants-json').textContent);
  var allImages = JSON.parse(document.getElementById('product-images-json').textContent);
  var sectionId = PD.sectionId;
  // Global doc URLs + product-type flag — used by updateFullSpecs() to keep the
  // Documentation card consistent across variant changes. Sourced from Liquid
  // so the JS path matches the snippet's render path.
  var IS_FRIDGE = PD.isFridge;
  var IS_FIRE_PIT = PD.isFirePit;
  var IS_BRANDED_DESIGN = PD.isBrandedDesign;
  var IN_BLACK_COLLECTION = PD.inBlackCollection === true;
  var CARE_STAINLESS_URL = 'https://cdn.shopify.com/s/files/1/0589/9147/6920/files/kc-care-stainless-steel_550a8321-ca1c-4997-8334-bc41de0ca0a5.pdf?v=1779339533';
  var CARE_SUNLIGHT_URL = 'https://cdn.shopify.com/s/files/1/0589/9147/6920/files/kc-guide-sunlight-and-placement_26d72518-1084-4f3e-af55-8165700c47fa.pdf?v=1787637700';
  // kc_specs.exterior_build -> display label. Mirrors EXTERIOR_BUILD_LABELS in
  // backend/domain/kc_specs.py and snippets/kc-specs-fallback.liquid.
  var EXTERIOR_BUILD_LABELS = {
    ss316_marine: '316 Marine Grade Stainless Steel',
    ss304: '304 Stainless Steel',
    ss304_black: 'Black Powder Coated 304 Stainless Steel'
  };
  var form = document.getElementById('product-form');
  var variantInput = document.getElementById('variant-id-input');
  var mainImage = document.getElementById('main-image');
  var mobileGalleryEl = document.getElementById('mobile-gallery');
  var mobileCounter = document.getElementById('mobile-counter');

  // ── Gallery video (first hosted video in product media) ──
  // Server-rendered nodes are captured once; rebuildGallery() re-appends them
  // after wiping innerHTML so listeners survive variant switches.
  var mainVideoWrap = document.getElementById('main-video-wrap');
  var stageVideo = mainVideoWrap ? mainVideoWrap.querySelector('video') : null;
  var videoThumbNode = document.querySelector('[data-video-thumb]');
  var videoSlideNode = document.querySelector('[data-video-slide]');
  var slideVideo = videoSlideNode ? videoSlideNode.querySelector('video') : null;
  function showStageVideo() {
    if (!mainVideoWrap) return;
    mainVideoWrap.style.display = '';
    document.querySelectorAll('[data-thumb]').forEach(function(t) {
      t.style.borderColor = '#d0d0d0';
      t.setAttribute('aria-current', 'false');
    });
    if (videoThumbNode) { videoThumbNode.style.borderColor = '#1a1a1a'; videoThumbNode.setAttribute('aria-current', 'true'); }
  }
  function hideStageVideo() {
    if (!mainVideoWrap) return;
    if (stageVideo && !stageVideo.paused) stageVideo.pause();
    mainVideoWrap.style.display = 'none';
    if (videoThumbNode) { videoThumbNode.style.borderColor = '#d0d0d0'; videoThumbNode.setAttribute('aria-current', 'false'); }
  }
  if (videoThumbNode) videoThumbNode.addEventListener('click', function(e) { e.stopPropagation(); showStageVideo(); });
  var priceEl = document.getElementById('price-current');
  var compareEl = document.getElementById('price-compare');
  var savingsEl = document.getElementById('price-savings');
  var desktopSku = document.getElementById('desktop-sku');
  var mobileSku = document.getElementById('mobile-sku');
  var stockEl = document.getElementById('stock-status');
  var payIn4El = document.getElementById('price-payin4');
  var payIn4Amount = document.getElementById('price-payin4-amount');
  var stockBadge = document.getElementById('stock-badge');
  var atcBtn = document.getElementById('add-to-cart-btn');
  var specsTable = document.getElementById('specs-table');
  var expertNotes = document.getElementById('expert-notes');
  var notifyWrap = document.getElementById('notify-me');
  var styleLabel = document.getElementById('variant-style-label');
  var aboutCollapse = document.getElementById('about-collapse');
  var aboutGradient = document.getElementById('about-gradient');
  var readMoreBtn = document.getElementById('read-more-btn');
  var aboutExpanded = false;

  var currentImageIndex = 0;
  var variantImagesMap = JSON.parse(document.getElementById('variant-images-json').textContent);

  // The alt-SKU map is load-bearing: consolidation-era products still carry other
  // SKUs' images (corona-bar-fridge holds 152 of them), so widening to allImages
  // would publish wrong-product photos. But a variant's own featured image must
  // never be filtered out of its own gallery, even when its alt text predates the
  // "{Title} - {SKU}" convention. Order follows product media order.
  // Leading media 0..N-1 ARE this product's designs when a design picker is present:
  // kc-design-picker.liquid's contract is "design_names[i] maps to product media index
  // i", over the LEADING images. They are frequently not SKU-tagged (alt '' or a generic
  // spec string), so the filter drops them and the pill goes dead. 0 without a picker,
  // so this is a no-op on every other product.
  var kcDesignCount = document.querySelectorAll('[data-kc-design-tab]').length;

  function galleryFor(variantId, featuredImage) {
    var idx = variantImagesMap[variantId];
    if (!idx || !idx.length) return allImages;   // unchanged no-match fallback
    var keep = {};
    for (var k = 0; k < idx.length; k++) keep[idx[k]] = true;
    var fsrc = featuredImage && featuredImage.src;
    return allImages.filter(function(img, i) {
      return keep[i] || i < kcDesignCount || (fsrc && img.src === fsrc);
    });
  }
  var activeImages = allImages; // filtered subset shown in the gallery

  // ── Category tabs (filter variant cards by "Small", "Upright" etc.) ──
  var categoryTabs = document.querySelectorAll('[data-category-tab]');
  var categoryTabLabel = document.getElementById('category-tab-label');
  var hasCategoryTabs = categoryTabs.length > 1;

  function activateCategoryTab(tabValue, autoSelectVariant) {
    if (!hasCategoryTabs) return;

    // Update tab pill styles
    categoryTabs.forEach(function(t) {
      var isActive = t.dataset.categoryTab === tabValue;
      t.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      t.style.border = isActive ? '2px solid #1a1a1a' : '2px solid #D5D9D9';
      t.style.background = isActive ? '#f7f4ee' : '#fff';
      t.style.fontWeight = isActive ? '700' : '500';
      t.style.boxShadow = isActive ? '0 0 0 1px #1a1a1a' : '0 2px 5px rgba(15,17,17,0.08)';
    });

    // Update label
    if (categoryTabLabel) categoryTabLabel.textContent = tabValue;

    // Show/hide variant cards based on category
    document.querySelectorAll('[data-variant-card]').forEach(function(card) {
      if (card.dataset.categoryValue) {
        if (card.dataset.categoryValue === tabValue) {
          card.classList.remove('hidden');
        } else {
          card.classList.add('hidden');
        }
      }
    });

    // Auto-select first visible variant in new tab (unless triggered by a card click)
    if (autoSelectVariant) {
      var firstVisible = document.querySelector('[data-variant-card][data-category-value="' + tabValue + '"]');
      if (firstVisible) {
        var vid = parseInt(firstVisible.dataset.variantId);
        var match = variants.find(function(v) { return v.id === vid; });
        if (match) {
          // Update card styles
          document.querySelectorAll('[data-variant-card]').forEach(function(c) {
            c.setAttribute('aria-pressed', 'false');
            c.style.border = '2px solid #e0e0e0';
            c.style.boxShadow = 'none';
          });
          firstVisible.setAttribute('aria-pressed', 'true');
          firstVisible.style.border = '2px solid #1a1a1a';
          firstVisible.style.boxShadow = '0 0 0 1px #1a1a1a';
          updateVariant(match);
        }
      }
    }
  }

  categoryTabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      activateCategoryTab(this.dataset.categoryTab, true);
    });
  });

  // ── Variant card clicks ──
  document.querySelectorAll('[data-variant-card]').forEach(function(card) {
    card.addEventListener('click', function() {
      var vid = parseInt(this.dataset.variantId);
      var match = variants.find(function(v) { return v.id === vid; });
      if (match) {
        // Update card styles (only among visible cards)
        document.querySelectorAll('[data-variant-card]').forEach(function(c) {
          c.setAttribute('aria-pressed', 'false');
          c.style.border = '2px solid #e0e0e0';
          c.style.boxShadow = 'none';
        });
        this.setAttribute('aria-pressed', 'true');
        this.style.border = '2px solid #1a1a1a';
        this.style.boxShadow = '0 0 0 1px #1a1a1a';

        // Sync the category tab if this card belongs to a different tab
        if (hasCategoryTabs && this.dataset.categoryValue) {
          activateCategoryTab(this.dataset.categoryValue, false);
        }

        updateVariant(match);
      }
    });
  });

  function formatMoney(cents) {
    var val = (cents / 100).toFixed(2);
    return '$' + val.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function isTruthy(v) {
    return v && ['true', 'yes'].indexOf(String(v).toLowerCase()) >= 0;
  }

  // Parse a raw metafield value that might be a measurement JSON string, plain number, or empty
  function parseNum(raw) {
    if (raw == null || raw === '' || raw === 'null') return null;
    // Try plain number first
    var n = parseFloat(raw);
    if (!isNaN(n)) return Math.round(n);
    // Try JSON measurement object: {"value":148.0,"unit":"LITERS"}
    try {
      var obj = JSON.parse(raw);
      if (obj && typeof obj.value === 'number') return Math.round(obj.value);
    } catch(e) {}
    return null;
  }

  // Pre-process variant meta: parse raw measurement fields into clean numbers
  variants.forEach(function(v) {
    var m = v.meta;
    m.volume = parseNum(m.volume_raw);
    m.width = parseNum(m.width);
    m.depth = parseNum(m.depth);
    m.height = parseNum(m.height);
    m.noise = parseNum(m.noise);
  });

  function updateVariant(v) {
    // addon-only PDPs render no product form (no standalone buy path), so the
    // hidden inputs / ATC button are absent — bail before dereferencing them.
    if (!variantInput) return;
    // Hidden input
    variantInput.value = v.id;

    // URL
    var url = new URL(window.location);
    url.searchParams.set('variant', v.id);
    history.replaceState(null, '', url);

    // Style label
    if (styleLabel) {
      styleLabel.innerHTML = 'Style: <strong>' + v.title.replace(/</g, '&lt;') + '</strong>';
    }

    // Price
    priceEl.textContent = formatMoney(v.price);
    if (v.compare_at_price && v.compare_at_price > v.price) {
      compareEl.textContent = formatMoney(v.compare_at_price);
      compareEl.classList.remove('hidden');
      var savings = v.compare_at_price - v.price;
      var pct = Math.round(savings / v.compare_at_price * 100);
      savingsEl.textContent = 'Save ' + formatMoney(savings) + ' (' + pct + '%)';
      savingsEl.classList.remove('hidden');
    } else {
      compareEl.textContent = '';
      compareEl.classList.add('hidden');
      savingsEl.textContent = '';
      savingsEl.classList.add('hidden');
    }
    if (payIn4El) {
      payIn4Amount.textContent = formatMoney(Math.round(v.price / 4));
      payIn4El.classList.toggle('hidden', v.price > 199999);
    }

    // SKU
    var sku = v.sku || '';
    if (desktopSku) desktopSku.textContent = sku;
    if (mobileSku) mobileSku.textContent = sku;

    // Image — filter gallery to this variant's images
    activeImages = galleryFor(v.id, v.featured_image);
    rebuildGallery(activeImages, v.featured_image);

    // Stock + ATC
    if (v.available) {
      var isPreOrder = v.inventory_management === 'shopify' && v.inventory_quantity <= 0;
      atcBtn.disabled = false;
      atcBtn.style.opacity = '1';
      atcBtn.textContent = isPreOrder ? 'Pre-Order' : 'Add to Cart';
      atcBtn.type = 'submit';
      if (isPreOrder) {
        var etaText = v.restock_eta ? 'Est. ' + v.restock_eta : 'Ships when available';
        stockEl.innerHTML = '<span class="inline-block w-2 h-2 rounded-full shrink-0 kc-stock-dot--preorder"></span>Pre-order &middot; ' + etaText;
        stockEl.style.color = '#d4a017';
      } else {
        stockEl.innerHTML = '<span class="inline-block w-2 h-2 rounded-full shrink-0 kc-stock-dot--instock"></span>In Stock';
        stockEl.style.color = '#15803d';
      }
      if (stockBadge) {
        if (isPreOrder) {
          var badgeEtaText = v.restock_eta ? 'Ships ' + v.restock_eta : 'Ships when available';
          stockBadge.innerHTML = '<span class="kc-stock-badge-dot kc-stock-badge-dot--instock"></span>Pre-order &middot; ' + badgeEtaText;
        } else {
          // Liquid owns this wording - free shipping, made to order and plain
          // in-stock all read differently, and hardcoding one of them here is
          // how the freight promise used to get overwritten with a claim we
          // could not keep.
          stockBadge.innerHTML = stockBadge.dataset.instockHtml
            || '<span class="kc-stock-badge-dot kc-stock-badge-dot--instock"></span>In stock - Ready to Ship';
        }
        stockBadge.style.color = '#15803d';
      }
      if (notifyWrap) notifyWrap.classList.add('hidden');
    } else {
      atcBtn.disabled = true;
      atcBtn.style.opacity = '0.4';
      atcBtn.textContent = 'Sold Out';
      atcBtn.type = 'button';
      stockEl.innerHTML = '<span class="inline-block w-2 h-2 rounded-full shrink-0 kc-stock-dot--soldout"></span>Sold Out';
      stockEl.style.color = '#CC0C39';
      if (stockBadge) {
        stockBadge.innerHTML = '<span class="kc-stock-badge-dot kc-stock-badge-dot--soldout"></span>Sold Out';
        stockBadge.style.color = '#CC0C39';
      }
      if (notifyWrap) notifyWrap.classList.remove('hidden');
    }

    // Specs table (quick specs above the fold)
    updateSpecs(v);

    // Expert notes
    updateExpertNotes(v.meta);

    // About + Specs tab content
    updateTabContent(v);

    // Dispatch event for shipping estimate, notify-me, etc.
    window.dispatchEvent(new CustomEvent('variant:change', {
      detail: { id: v.id, sku: v.sku, price: v.price, available: v.available, meta: v.meta }
    }));
  }

  function capitalize(s) {
    if (!s) return '';
    return String(s).charAt(0).toUpperCase() + String(s).slice(1);
  }

  function updateSpecs(v) {
    // Fire pit quick specs are server-rendered by kc-fire-pit-specs.liquid —
    // the fridge-shaped rebuild below would clobber them with empty rows.
    if (IS_FIRE_PIT) return;
    if (!specsTable) return;
    var meta = v.meta || {};
    var html = '';

    // Model
    html += '<div class="flex py-2" style="border-bottom:1px solid #e0e0e0" data-spec="model">';
    html += '<span class="w-[90px] md:w-[110px] shrink-0 text-[11px] font-medium text-rb-ink-muted">Model</span>';
    html += '<span class="text-[11px] font-semibold text-[#1a1a1a]">' + (v.sku || '') + '</span>';
    html += '</div>';

    // Dimensions
    if (meta.width && meta.depth && meta.height) {
      html += '<div class="flex py-2" style="border-bottom:1px solid #e0e0e0" data-spec="dimensions">';
      html += '<span class="w-[90px] md:w-[110px] shrink-0 text-[11px] font-medium text-rb-ink-muted">Dimensions</span>';
      html += '<span class="text-[11px] font-semibold text-[#1a1a1a]">' + meta.width + 'W \u00d7 ' + meta.depth + 'D \u00d7 ' + meta.height + 'Hmm</span>';
      html += '</div>';
    }

    // Capacity
    if (meta.capacity != null) {
      var cap = meta.capacity + 'L';
      if (meta.cans != null && meta.bottles != null) cap += ' (' + meta.cans + ' cans / ' + meta.bottles + ' bottles)';
      else if (meta.cans != null) cap += ' (' + meta.cans + ' cans)';
      else if (meta.bottles != null) cap += ' (' + meta.bottles + ' bottles)';
      html += '<div class="flex py-2" style="border-bottom:1px solid #e0e0e0' + (IS_BRANDED_DESIGN ? ';flex-wrap:wrap' : '') + '" data-spec="capacity">';
      html += '<span class="w-[90px] md:w-[110px] shrink-0 text-[11px] font-medium text-rb-ink-muted">Capacity</span>';
      html += '<span class="text-[11px] font-semibold text-[#1a1a1a]">' + cap + '</span>';
      if (IS_BRANDED_DESIGN) {
        html += '<button type="button" class="kc-size-swap-link" data-size-swap-ask>Different size? We can do that \u2192</button>';
      }
      html += '</div>';
    }

    // Hinge — kc_specs enum is "left" | "right" | "both"
    if (meta.hinge) {
      html += '<div class="flex py-2" style="border-bottom:1px solid #e0e0e0" data-spec="hinge">';
      html += '<span class="w-[90px] md:w-[110px] shrink-0 text-[11px] font-medium text-rb-ink-muted">Hinge</span>';
      html += '<span class="text-[11px] font-semibold text-[#1a1a1a]">' + capitalize(meta.hinge) + '</span>';
      html += '</div>';
    }

    // Door — kc_specs enum is "solid" | "glass" | "open", heated is a separate bool.
    // Render as composite ("Heated Glass" / "Glass" / "Solid") to match PDP server render.
    if (meta.door_type) {
      var doorLabel = (meta.heated === true && meta.door_type === 'glass')
        ? 'Heated ' + capitalize(meta.door_type)
        : capitalize(meta.door_type);
      html += '<div class="flex py-2" style="border-bottom:1px solid #e0e0e0" data-spec="door">';
      html += '<span class="w-[90px] md:w-[110px] shrink-0 text-[11px] font-medium text-rb-ink-muted">Door</span>';
      html += '<span class="text-[11px] font-semibold text-[#1a1a1a]">' + doorLabel + '</span>';
      html += '</div>';
    }

    // Running cost — estimated annual electricity (AUD/yr), mirrors the server render above
    if (meta.running_cost != null) {
      html += '<div class="flex py-2" style="border-bottom:1px solid #e0e0e0" data-spec="running-cost">';
      html += '<span class="w-[90px] md:w-[110px] shrink-0 text-[11px] font-medium text-rb-ink-muted">Running Cost</span>';
      html += '<span class="text-[11px] font-semibold text-[#1a1a1a]">$' + Math.round(parseFloat(meta.running_cost)) + '/yr<span class="text-rb-ink-muted font-normal"> est.</span></span>';
      html += '</div>';
    }

    specsTable.innerHTML = html + '<div id="expert-notes"></div>';
    expertNotes = document.getElementById('expert-notes');
  }

  function updateExpertNotes(meta) {
    if (!expertNotes || !meta) return;
    var html = '';
    // 316 stainless
    if (meta.certifications && String(meta.certifications).indexOf('316') >= 0) {
      html += '<div class="flex py-2" style="border-bottom:none" data-note="316">';
      html += '<span class="w-[90px] md:w-[110px] shrink-0 text-[9px] font-bold uppercase tracking-[0.08em] text-[#1a1a1a] pt-px" style="font-family:\'Space Mono\', monospace">Expert Note</span>';
      html += '<span class="text-[11px] font-medium text-[#1a1a1a]">316 marine-grade stainless \u2014 built to resist salt corrosion near the coast or around saltwater pools</span>';
      html += '</div>';
    }
    // Heated glass (kc_specs.heated bool) — only relevant for glass doors
    if (meta.heated === true && meta.door_type === 'glass') {
      html += '<div class="flex py-2" style="border-bottom:none" data-note="heated">';
      html += '<span class="w-[90px] md:w-[110px] shrink-0 text-[9px] font-bold uppercase tracking-[0.08em] text-[#1a1a1a] pt-px" style="font-family:\'Space Mono\', monospace">Expert Note</span>';
      html += '<span class="text-[11px] font-medium text-[#1a1a1a]">Heated glass keeps the door above dew point \u2014 prevents fogging and condensation in humid outdoor setups</span>';
      html += '</div>';
    }
    // Silent operation (0dB thermoelectric)
    if (meta.noise === 0) {
      html += '<div class="flex py-2" style="border-bottom:none" data-note="silent">';
      html += '<span class="w-[90px] md:w-[110px] shrink-0 text-[9px] font-bold uppercase tracking-[0.08em] text-[#1a1a1a] pt-px" style="font-family:\'Space Mono\', monospace">Expert Note</span>';
      html += '<span class="text-[11px] font-medium text-[#1a1a1a]">0dB thermoelectric cooling \u2014 completely silent operation, ideal for hotel rooms, motels, nursing homes & sleeping quarters</span>';
      html += '</div>';
    }
    expertNotes.innerHTML = html;
  }

  // ── Update About + Specs tab content on variant switch ──
  // Cache fetched section HTML per variant to avoid re-fetching
  var variantContentCache = {};

  function updateTabContent(v) {
    // Update specs immediately from meta (these are in the variant JSON)
    updateFullSpecs(v);

    // Fetch About content via Section Rendering API (handles all metafield types correctly)
    var vid = v.id;
    if (variantContentCache[vid]) {
      applyAboutHtml(variantContentCache[vid]);
      return;
    }

    // Fetch section HTML for this variant
    var url = window.location.pathname + '?variant=' + vid + '&section_id=' + sectionId;
    fetch(url)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        // Extract desktop About panel content
        var newAbout = doc.querySelector('[data-tab-panel="about"] .space-y-6');
        var aboutHtml = newAbout ? newAbout.innerHTML : '';
        variantContentCache[vid] = aboutHtml;
        // Only apply if still the active variant
        if (variantInput.value == vid) {
          applyAboutHtml(aboutHtml);
        }
      })
      .catch(function() { /* silently fail — keep current content */ });
  }

  function applyAboutHtml(html) {
    var desktopAbout = document.querySelector('[data-tab-panel="about"] .space-y-6');
    if (desktopAbout) desktopAbout.innerHTML = html;
    var mobileAbout = document.getElementById('about-content');
    if (mobileAbout) mobileAbout.innerHTML = html;
    // Reset Read More state
    aboutExpanded = false;
    if (aboutCollapse) aboutCollapse.style.maxHeight = '480px';
    if (aboutGradient) aboutGradient.style.display = '';
    if (readMoreBtn) readMoreBtn.textContent = 'Read more';
  }

  function updateFullSpecs(v) {
    // Fire pit specs are server-rendered (kc-fire-pit-specs.liquid, mode: full).
    if (IS_FIRE_PIT) return;
    var meta = v.meta || {};
    var cardN = 0;
    function num() { cardN += 1; return '0' + cardN; }
    function row(label, valueHtml) {
      return '<div class="kc-specs-card-row">'
        + '<span class="kc-specs-card-label">' + label + '</span>'
        + '<span class="kc-specs-card-value">' + valueHtml + '</span>'
        + '</div>';
    }
    function card(title, rowsHtml, extraClass) {
      if (!rowsHtml) return '';
      var cls = 'kc-specs-card' + (extraClass ? ' ' + extraClass : '');
      return '<div class="' + cls + '">'
        + '<div class="kc-specs-card-head"><span class="kc-specs-num">' + num() + '</span><h3>' + title + '</h3></div>'
        + rowsHtml + '</div>';
    }
    function docRow(title, meta, href) {
      // File-reference metafields can serialise as an {error} object, not a URL
      if (typeof href !== 'string') return '';
      var rel = href.indexOf('barfridgesaustralia') !== -1 ? 'noopener nofollow' : 'noopener';
      return '<a class="kc-doc-row" href="' + escapeHtml(href) + '" target="_blank" rel="' + rel + '" aria-label="Open ' + escapeHtml(title) + ' PDF in new tab">'
        + '<span class="kc-doc-icon">PDF</span>'
        + '<span class="kc-doc-body">'
          + '<span class="kc-doc-title">' + escapeHtml(title) + '</span>'
          + '<span class="kc-doc-meta">' + escapeHtml(meta) + '</span>'
        + '</span>'
        + '<span class="kc-doc-arrow">Download &rarr;</span>'
      + '</a>';
    }

    // Dimensions
    var dims = '';
    if (v.sku) dims += row('Model', escapeHtml(v.sku));
    if (meta.width && meta.depth && meta.height) {
      dims += row('W \u00d7 D \u00d7 H', '<strong>' + escapeHtml(String(meta.width)) + '</strong> \u00d7 ' + escapeHtml(String(meta.depth)) + ' \u00d7 ' + escapeHtml(String(meta.height)) + ' mm');
    }
    if (meta.internal_h_mm && meta.internal_w_mm && meta.internal_d_mm) {
      dims += row('Internal W \u00d7 D \u00d7 H', escapeHtml(String(meta.internal_w_mm)) + ' \u00d7 ' + escapeHtml(String(meta.internal_d_mm)) + ' \u00d7 ' + escapeHtml(String(meta.internal_h_mm)) + ' mm');
    }
    if (meta.capacity != null) {
      var cap = '<strong>' + escapeHtml(String(meta.capacity)) + 'L</strong>';
      if (meta.cans != null) cap += ' \u00b7 ' + escapeHtml(String(meta.cans)) + ' cans';
      if (meta.bottles != null) cap += ' \u00b7 ' + escapeHtml(String(meta.bottles)) + ' bottles';
      dims += row('Capacity', cap);
    }
    if (meta.doors) dims += row('Doors', escapeHtml(String(meta.doors)));
    if (meta.weight != null && parseFloat(meta.weight) > 0) {
      dims += row('Weight', '<strong>' + escapeHtml(String(meta.weight)) + '</strong> ' + escapeHtml(meta.weight_unit || 'kg'));
    }

    // Performance
    var perf = '';
    if (meta.noise != null) {
      var noiseDisplay = meta.noise === 0 ? '0dB (silent)' : meta.noise + ' dB';
      perf += row('Noise', '<strong>' + escapeHtml(noiseDisplay) + '</strong>');
    }
    if (meta.power_kwh) perf += row('Power', escapeHtml(String(meta.power_kwh)) + ' kWh/24h');
    if (meta.energy_rating) perf += row('Energy Rating', '<strong>' + escapeHtml(String(meta.energy_rating)) + '</strong> stars');
    if (meta.running_cost != null) perf += row('Running Cost', '<strong>$' + Math.round(parseFloat(meta.running_cost)) + '</strong>/yr est.');
    if (meta.location) perf += row('Location', escapeHtml(meta.location === 'both' ? 'Indoor / Outdoor' : capitalize(meta.location)));

    // Build
    var build = '';
    if (meta.door_type) {
      var doorLabel = (meta.heated === true && meta.door_type === 'glass')
        ? 'Heated Glass'
        : capitalize(meta.door_type);
      build += row('Door Type', escapeHtml(doorLabel));
    }
    if (meta.hinge) build += row('Hinge', escapeHtml(capitalize(meta.hinge)));
    if (meta.colour) {
      // Mirrors snippets/kc-specs-fallback.liquid: a black fridge links to the black spoke.
      var finishHtml = escapeHtml(capitalize(meta.colour));
      if (meta.colour === 'black' && IN_BLACK_COLLECTION) {
        finishHtml += ' &middot; <a href="/collections/black-bar-fridges">Shop black bar fridges</a>';
      }
      build += row('Finish', finishHtml);
    }
    // Exterior build. 316 is the top tier, so flag it: the premium ranges
    // (Rhino ENV, Blastcool iXP) should read as the best build on the page,
    // not as just another material string.
    if (meta.exterior_build && EXTERIOR_BUILD_LABELS[meta.exterior_build]) {
      var buildLabel = escapeHtml(EXTERIOR_BUILD_LABELS[meta.exterior_build]);
      if (meta.exterior_build === 'ss316_marine') {
        buildLabel = '<strong>' + buildLabel + '</strong> <span class="kc-specs-chip kc-specs-chip--featured">Best</span>';
      }
      build += row('Exterior', buildLabel);
    }
    if (meta.lockable === true) build += row('Lockable', '<a href="/collections/lockable-bar-fridges">Yes</a>');
    if (meta.reversible === true) build += row('Reversible', 'Yes');

    // Documentation
    var docs = '';
    if (v.brochure_url) docs += docRow('Product Brochure', v.sku || '', v.brochure_url);
    if (v.spec_sheet_url) docs += docRow('Spec Sheet', 'Dimension drawing & cavity sizes', v.spec_sheet_url);
    if (v.user_manual_url) docs += docRow('User Manual', 'Installation & operation guide', v.user_manual_url);
    if (IS_FRIDGE) {
      docs += docRow('Stainless Steel Care Guide', 'Cleaning & maintenance', CARE_STAINLESS_URL);
      docs += docRow('Sunlight & Placement', 'Placement, ambient ratings & IP', CARE_SUNLIGHT_URL);
    }

    var html = '<div class="kc-specs-grid">'
      + card('Dimensions', dims)
      + card('Performance', perf)
      + card('Build', build)
      + card('Documentation', docs);

    // Ventilation & Installation \u2014 full-width clearance/cavity stat tiles
    var hasInstall = IS_FRIDGE && (
      meta.vent_rear_mm != null || meta.vent_sides_mm != null || meta.vent_top_mm != null ||
      meta.cavity_h_mm || meta.cavity_w_mm || meta.cavity_d_mm
    );
    if (hasInstall) {
      var stats = '';
      if (meta.vent_rear_mm != null || meta.vent_sides_mm != null || meta.vent_top_mm != null) {
        var clr = '';
        if (meta.vent_rear_mm != null) clr += '<strong>' + escapeHtml(String(meta.vent_rear_mm)) + '</strong> mm rear';
        if (meta.vent_sides_mm != null) clr += (clr ? '<br>' : '') + '<strong>' + escapeHtml(String(meta.vent_sides_mm)) + '</strong> mm sides';
        if (meta.vent_top_mm != null) clr += (clr ? '<br>' : '') + '<strong>' + escapeHtml(String(meta.vent_top_mm)) + '</strong> mm top';
        stats += '<div class="kc-install-stat"><span class="kc-install-stat-label">Required clearance</span><span class="kc-install-stat-value">' + clr + '</span></div>';
      }
      if (meta.cavity_h_mm && meta.cavity_w_mm && meta.cavity_d_mm) {
        stats += '<div class="kc-install-stat"><span class="kc-install-stat-label">Minimum cavity</span><span class="kc-install-stat-value"><strong>' + escapeHtml(String(meta.cavity_h_mm)) + '</strong> \u00d7 <strong>' + escapeHtml(String(meta.cavity_w_mm)) + '</strong> \u00d7 <strong>' + escapeHtml(String(meta.cavity_d_mm)) + '</strong> mm<br><span class="kc-install-stat-hint">H \u00d7 W \u00d7 D</span></span></div>';
      }

      html += '<div class="kc-specs-card kc-specs-card--install">'
        + '<div class="kc-specs-card-head"><span class="kc-specs-num">' + num() + '</span><h3>Ventilation &amp; Installation</h3></div>'
        + '<div class="kc-install-stats">' + stats + '</div>'
        + '</div>';
    }

    // Compliance \u2014 full-width inverted card with chips
    if (meta.certifications) {
      var chips = String(meta.certifications).split(',').map(function(c){ return c.trim(); }).filter(Boolean);
      var chipHtml = chips.map(function(c){
        var upper = c.toUpperCase();
        var featured = (upper.indexOf('IP') === 0 || upper.indexOf('MEPS') !== -1) ? ' kc-specs-chip--featured' : '';
        return '<span class="kc-specs-chip' + featured + '">' + escapeHtml(c) + '</span>';
      }).join('');
      html += '<div class="kc-specs-card kc-specs-card--compliance">'
        + '<div class="kc-specs-card-head"><span class="kc-specs-num">' + num() + '</span><h3>Compliance &amp; Certifications</h3></div>'
        + '<div class="kc-specs-chips">' + chipHtml + '</div>'
        + '</div>';
    }
    html += '</div>';

    var desktopSpecs = document.querySelector('[data-tab-panel="specs"]');
    if (desktopSpecs) desktopSpecs.innerHTML = html;
    var mobileSpecs = document.getElementById('full-specs-content');
    if (mobileSpecs) mobileSpecs.innerHTML = html;
  }

  function escapeHtml(str) {
    if (!str) return '';
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // ── Gallery: rebuild thumbnails + dots for a filtered image set ──
  function rebuildGallery(images, featuredImage) {
    var thumbStrip = document.getElementById('thumb-strip');
    var dotsContainer = document.getElementById('mobile-dots');
    hideStageVideo();

    // Determine which image to show first — prefer variant's featured image
    var startIdx = 0;
    if (featuredImage) {
      for (var i = 0; i < images.length; i++) {
        if (images[i].src === featuredImage.src) { startIdx = i; break; }
      }
    }

    // Rebuild desktop thumbnails
    if (thumbStrip) {
      thumbStrip.innerHTML = '';
      if (images.length > 1) {
        thumbStrip.style.display = '';
        images.forEach(function(img, i) {
          var btn = document.createElement('button');
          btn.setAttribute('aria-label', 'View image ' + (i + 1));
          btn.className = 'relative flex-shrink-0 bg-white overflow-hidden transition-colors';
          btn.style.cssText = 'width:80px;height:80px;border:1px solid ' + (i === startIdx ? '#1a1a1a' : '#d0d0d0');
          btn.dataset.thumb = '';
          btn.dataset.imageUrl = img.src;
          btn.dataset.imageAlt = img.alt;
          btn.dataset.thumbIndex = i;
          btn.setAttribute('role', 'listitem');
          btn.setAttribute('aria-current', i === startIdx ? 'true' : 'false');
          var thumbImg = document.createElement('img');
          thumbImg.alt = img.alt || '';
          thumbImg.loading = 'lazy';
          thumbImg.decoding = 'async';
          thumbImg.className = 'object-contain p-1.5';
          thumbImg.style.cssText = 'position:absolute;height:100%;width:100%;left:0;top:0;right:0;bottom:0;color:transparent';
          thumbImg.src = img.thumb;
          thumbImg.width = 80;
          thumbImg.height = 80;
          btn.appendChild(thumbImg);
          btn.addEventListener('click', function() { goToImage(i); });
          thumbStrip.appendChild(btn);
        });
      } else {
        thumbStrip.style.display = 'none';
      }
      // Re-append the server-rendered video thumb (innerHTML wipe detached it;
      // the saved node keeps its click listener)
      if (videoThumbNode) {
        thumbStrip.appendChild(videoThumbNode);
        thumbStrip.style.display = '';
      }
    }

    // Rebuild mobile scroll-snap track (skip if the existing track already matches)
    var existingSlides = mobileGalleryEl ? mobileGalleryEl.querySelectorAll('[data-slide]') : null;
    var trackMatches = existingSlides && existingSlides.length === images.length && Array.prototype.every.call(existingSlides, function(s, i) {
      return s.dataset.imageId === images[i].id;
    });
    if (mobileGalleryEl && !trackMatches) {
      mobileGalleryEl.innerHTML = '';
      images.forEach(function(img, i) {
        var slide = document.createElement('div');
        slide.className = 'relative flex-shrink-0 w-full h-full';
        slide.style.cssText = 'scroll-snap-align:center;scroll-snap-stop:always';
        slide.dataset.slide = i;
        slide.dataset.imageId = img.id;
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');
        slide.setAttribute('aria-label', 'Image ' + (i + 1) + ' of ' + images.length);
        var slideImg = document.createElement('img');
        slideImg.alt = img.alt || '';
        slideImg.decoding = 'async';
        slideImg.className = 'object-contain p-4';
        slideImg.style.cssText = 'position:absolute;height:100%;width:100%;left:0;top:0;right:0;bottom:0;color:transparent';
        slideImg.src = img.src;
        slideImg.sizes = '100vw';
        slideImg.width = 600;
        slideImg.height = 600;
        slideImg.loading = i === 0 ? 'eager' : 'lazy';
        if (i === 0) slideImg.setAttribute('fetchpriority', 'high');
        slide.appendChild(slideImg);
        mobileGalleryEl.appendChild(slide);
      });
      // Re-append the video slide at the end of the rebuilt track
      if (videoSlideNode) {
        videoSlideNode.dataset.slide = images.length;
        mobileGalleryEl.appendChild(videoSlideNode);
      }
    }

    // Rebuild mobile dots
    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      var maxDots = Math.min(images.length, 5);
      for (var d = 0; d < maxDots; d++) {
        var dot = document.createElement('button');
        dot.setAttribute('aria-label', 'View image ' + (d + 1));
        dot.className = 'rounded-full transition-all';
        dot.dataset.dot = d;
        if (d === startIdx) {
          dot.style.cssText = 'width:8px;height:8px;background:#0F1111';
        } else if (Math.abs(d - startIdx) <= 1) {
          dot.style.cssText = 'width:6px;height:6px;background:rgba(15,17,17,0.25)';
        } else {
          dot.style.cssText = 'width:4px;height:4px;background:rgba(15,17,17,0.12)';
        }
        (function(idx) {
          dot.addEventListener('click', function() { goToImage(idx); });
        })(d);
        dotsContainer.appendChild(dot);
      }
      // Video dot — last slide on the mobile track (matches the Liquid render)
      if (videoSlideNode && images.length < 5) {
        var vdot = document.createElement('button');
        vdot.setAttribute('aria-label', 'View product video');
        vdot.className = 'rounded-full transition-all';
        vdot.dataset.dot = images.length;
        vdot.style.cssText = 'width:4px;height:4px;background:rgba(15,17,17,0.12)';
        vdot.addEventListener('click', function() {
          var vs = mobileGalleryEl ? mobileGalleryEl.querySelector('[data-video-slide]') : null;
          if (vs) mobileGalleryEl.scrollTo({ left: vs.offsetLeft, behavior: 'smooth' });
        });
        dotsContainer.appendChild(vdot);
      }
    }

    // Show/hide prev/next arrows based on image count
    var prevBtn = document.querySelector('[data-gallery-prev]');
    var nextBtn = document.querySelector('[data-gallery-next]');
    if (prevBtn) prevBtn.style.display = images.length > 1 ? '' : 'none';
    if (nextBtn) nextBtn.style.display = images.length > 1 ? '' : 'none';

    // Snap mobile track to the starting image instantly (avoids visible smooth-scroll on variant switch)
    if (mobileGalleryEl) {
      var startSlide = mobileGalleryEl.querySelector('[data-slide="' + startIdx + '"]');
      if (startSlide) {
        suppressScrollSync = true;
        mobileGalleryEl.scrollLeft = startSlide.offsetLeft;
        setTimeout(function() { suppressScrollSync = false; }, 400);
      }
    }
    // Lightbox filmstrip - same source of truth as every other surface. Reached by
    // getElementById, never by calling into the lightbox block (which is scoped inside
    // `if (desktopGallery && mainImage)` and only reachable out here via Annex B
    // hoisting). Clicks are handled by a delegated listener bound once in that block.
    // NB: these buttons must NOT carry data-thumb - goToImage highlights the main strip
    // with a positional querySelectorAll('[data-thumb]') and they would corrupt it.
    var filmstrip = document.getElementById('kc-lightbox-filmstrip');
    if (filmstrip) {
      filmstrip.innerHTML = '';
      images.forEach(function(img, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'View image ' + (i + 1));
        b.dataset.lbThumb = i;
        b.style.cssText = 'width:56px;height:56px;flex-shrink:0;border:2px solid ' +
          (i === startIdx ? '#c75a2a' : 'transparent') +
          ';cursor:pointer;overflow:hidden;transition:border-color .2s,opacity .2s;opacity:' +
          (i === startIdx ? '1' : '0.5') + ';background:none;padding:0';
        if (i === startIdx) b.classList.add('kc-lb-active');
        b.addEventListener('mouseover', function() { b.style.opacity = '0.8'; });
        b.addEventListener('mouseout', function() {
          if (!b.classList.contains('kc-lb-active')) b.style.opacity = '0.5';
        });
        var im = document.createElement('img');
        im.src = img.thumb; im.alt = img.alt || '';
        im.loading = 'lazy'; im.decoding = 'async';
        im.width = 56; im.height = 56;
        im.style.cssText = 'width:100%;height:100%;object-fit:cover';
        b.appendChild(im);
        filmstrip.appendChild(b);
      });
    }

    // Jump to the starting image (updates desktop main image, counter, dots, thumbs)
    goToImage(startIdx);
  }

  // Design picker (snippets/kc-design-picker.liquid) → swap gallery to the matching leading image.
  document.addEventListener('kc:design-image', function(e) {
    // kc-design-picker.liquid dispatches a PRODUCT MEDIA index (design_names[i] maps to
    // product media index i). activeImages is the filtered set, so the two index spaces
    // only coincide on unfiltered products - translate by identity, never by position.
    var i = e && e.detail ? e.detail.index : 0;
    if (typeof i !== 'number' || i < 0 || i >= allImages.length) return;
    var target = allImages[i].src;
    for (var j = 0; j < activeImages.length; j++) {
      if (activeImages[j].src === target) { goToImage(j); return; }
    }
    // design image is filtered out of this variant's gallery - leave the stage alone
  });

  // ── Gallery: desktop prev/next arrows ──
  var prevBtn = document.querySelector('[data-gallery-prev]');
  var nextBtn = document.querySelector('[data-gallery-next]');
  var suppressScrollSync = false;
  function updateMobileDots(idx) {
    document.querySelectorAll('[data-dot]').forEach(function(dot) {
      var di = parseInt(dot.dataset.dot);
      if (di === idx) {
        dot.style.width = '8px'; dot.style.height = '8px'; dot.style.background = '#0F1111';
      } else if (Math.abs(di - idx) <= 1) {
        dot.style.width = '6px'; dot.style.height = '6px'; dot.style.background = 'rgba(15,17,17,0.25)';
      } else {
        dot.style.width = '4px'; dot.style.height = '4px'; dot.style.background = 'rgba(15,17,17,0.12)';
      }
    });
  }
  function goToImage(idx) {
    hideStageVideo();
    if (idx < 0) idx = activeImages.length - 1;
    if (idx >= activeImages.length) idx = 0;
    currentImageIndex = idx;
    var img = activeImages[idx];
    if (mainImage) { mainImage.src = img.src; mainImage.alt = img.alt; mainImage.srcset = ''; }
    if (mobileGalleryEl) {
      var slide = mobileGalleryEl.querySelector('[data-slide="' + idx + '"]');
      if (slide) {
        suppressScrollSync = true;
        mobileGalleryEl.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        setTimeout(function() { suppressScrollSync = false; }, 400);
      }
    }
    if (mobileCounter) mobileCounter.textContent = (idx + 1) + ' / ' + (activeImages.length + (videoSlideNode ? 1 : 0));
    // Update thumbnails
    document.querySelectorAll('[data-thumb]').forEach(function(t, i) {
      t.style.borderColor = (i === idx) ? '#1a1a1a' : '#d0d0d0';
      t.setAttribute('aria-current', i === idx ? 'true' : 'false');
    });
    updateMobileDots(idx);
    if (typeof preloadAdjacent === 'function') preloadAdjacent();
  }
  if (prevBtn) prevBtn.addEventListener('click', function(e) { e.stopPropagation(); goToImage(currentImageIndex - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function(e) { e.stopPropagation(); goToImage(currentImageIndex + 1); });

  // ── Gallery: click-to-lightbox (no hover zoom) ──
  var desktopGallery = document.getElementById('desktop-gallery');
  if (desktopGallery && mainImage) {
    var lightbox = document.getElementById('kc-lightbox');
    var lightboxImg = document.getElementById('kc-lightbox-img');
    var lightboxClose = document.getElementById('kc-lightbox-close');
    var lightboxPrev = document.getElementById('kc-lightbox-prev');
    var lightboxNext = document.getElementById('kc-lightbox-next');
    var lightboxCounter = document.getElementById('kc-lightbox-counter');
    var lightboxStage = document.getElementById('kc-lightbox-stage');
    var lightboxZoomIn = document.getElementById('kc-lightbox-zoom-in');
    var lightboxZoomOut = document.getElementById('kc-lightbox-zoom-out');
    var lightboxZoomReset = document.getElementById('kc-lightbox-zoom-reset');
    var lightboxZoomLevel = document.getElementById('kc-lightbox-zoom-level');
    var lightboxFilmstrip = document.getElementById('kc-lightbox-filmstrip');
    // NB: no cached NodeList - the filmstrip is rebuilt by rebuildGallery, so any
    // capture taken here goes stale. Query live at use.

    var lbZoom = 1, lbPanX = 0, lbPanY = 0;
    var lbDragging = false, lbDragStartX, lbDragStartY, lbStartPanX, lbStartPanY;

    function lbSetZoom(z) {
      lbZoom = Math.max(1, Math.min(5, z));
      if (lbZoom === 1) { lbPanX = 0; lbPanY = 0; }
      lightboxImg.style.transform = 'scale(' + lbZoom + ') translate(' + lbPanX + 'px, ' + lbPanY + 'px)';
      lightboxZoomLevel.textContent = lbZoom.toFixed(1) + 'x';
      lightboxStage.style.cursor = lbZoom > 1 ? 'grab' : 'zoom-in';
    }
    function lbResetZoom() { lbPanX = 0; lbPanY = 0; lbSetZoom(1); }

    function lbUpdateThumbs() {
      document.querySelectorAll('[data-lb-thumb]').forEach(function(t) {
        var idx = parseInt(t.dataset.lbThumb);
        var isActive = idx === currentImageIndex;
        t.style.borderColor = isActive ? '#c75a2a' : 'transparent';
        t.style.opacity = isActive ? '1' : '0.5';
        if (isActive) t.classList.add('kc-lb-active');
        else t.classList.remove('kc-lb-active');
      });
    }

    function lbGoTo(idx) {
      goToImage(idx);
      lightboxImg.src = mainImage.src;
      lightboxImg.alt = mainImage.alt;
      lightboxCounter.textContent = (currentImageIndex + 1) + ' / ' + activeImages.length;
      lbResetZoom();
      lbUpdateThumbs();
    }

    function openLightbox() {
      lightboxImg.src = mainImage.src;
      lightboxImg.alt = mainImage.alt;
      lightboxCounter.textContent = (currentImageIndex + 1) + ' / ' + activeImages.length;
      lightbox.style.display = 'flex';
      lightbox.offsetHeight;
      lightbox.style.opacity = '1';
      document.body.style.overflow = 'hidden';
      lbResetZoom();
      lbUpdateThumbs();
      var hasMultiple = activeImages && activeImages.length > 1;
      lightboxPrev.style.display = hasMultiple ? '' : 'none';
      lightboxNext.style.display = hasMultiple ? '' : 'none';
    }
    function closeLightbox() {
      lightbox.style.opacity = '0';
      setTimeout(function() {
        lightbox.style.display = 'none';
        document.body.style.overflow = '';
      }, 300);
    }

    // Open on click (not on arrow clicks; not while the stage video is active —
    // those clicks belong to the player controls)
    desktopGallery.addEventListener('click', function(e) {
      if (e.target.closest('[data-gallery-prev]') || e.target.closest('[data-gallery-next]')) return;
      if (mainVideoWrap && mainVideoWrap.style.display !== 'none') return;
      openLightbox();
    });

    // Close
    lightboxClose.addEventListener('click', closeLightbox);

    // Nav
    lightboxPrev.addEventListener('click', function(e) { e.stopPropagation(); lbGoTo(currentImageIndex - 1); });
    lightboxNext.addEventListener('click', function(e) { e.stopPropagation(); lbGoTo(currentImageIndex + 1); });

    // Filmstrip thumbs
    // Delegated: the filmstrip's children are replaced on every rebuildGallery, so
    // per-node listeners would not survive. Each button wraps a full-bleed <img>, so
    // e.target is essentially never the button - closest() is required, not optional.
    if (lightboxFilmstrip) {
      lightboxFilmstrip.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-lb-thumb]');
        if (!btn) return;
        e.stopPropagation();
        lbGoTo(parseInt(btn.dataset.lbThumb, 10));
      });
    }

    // Zoom controls
    lightboxZoomIn.addEventListener('click', function(e) { e.stopPropagation(); lbSetZoom(lbZoom + 0.5); });
    lightboxZoomOut.addEventListener('click', function(e) { e.stopPropagation(); lbSetZoom(lbZoom - 0.5); });
    lightboxZoomReset.addEventListener('click', function(e) { e.stopPropagation(); lbResetZoom(); });

    // Scroll to zoom
    lightboxStage.addEventListener('wheel', function(e) {
      e.preventDefault();
      lbSetZoom(lbZoom + (e.deltaY > 0 ? -0.3 : 0.3));
    }, { passive: false });

    // Pan when zoomed (drag)
    lightboxStage.addEventListener('mousedown', function(e) {
      if (lbZoom <= 1) return;
      if (e.target.closest('button')) return;
      lbDragging = true;
      lightboxStage.style.cursor = 'grabbing';
      lbDragStartX = e.clientX;
      lbDragStartY = e.clientY;
      lbStartPanX = lbPanX;
      lbStartPanY = lbPanY;
      e.preventDefault();
    });
    window.addEventListener('mousemove', function(e) {
      if (!lbDragging) return;
      lbPanX = lbStartPanX + (e.clientX - lbDragStartX) / lbZoom;
      lbPanY = lbStartPanY + (e.clientY - lbDragStartY) / lbZoom;
      lightboxImg.style.transform = 'scale(' + lbZoom + ') translate(' + lbPanX + 'px, ' + lbPanY + 'px)';
    });
    window.addEventListener('mouseup', function() {
      if (lbDragging) {
        lbDragging = false;
        lightboxStage.style.cursor = lbZoom > 1 ? 'grab' : 'zoom-in';
      }
    });

    // Click stage to zoom in (when at 1x)
    lightboxStage.addEventListener('click', function(e) {
      if (e.target.closest('button') || e.target.closest('[style*="position:absolute;bottom:24px"]')) return;
      if (lbZoom === 1) lbSetZoom(2);
    });

    // Keyboard
    document.addEventListener('keydown', function(e) {
      if (lightbox.style.display !== 'flex') return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') lbGoTo(currentImageIndex - 1);
      if (e.key === 'ArrowRight') lbGoTo(currentImageIndex + 1);
      if (e.key === '+' || e.key === '=') lbSetZoom(lbZoom + 0.5);
      if (e.key === '-') lbSetZoom(lbZoom - 0.5);
      if (e.key === '0') lbResetZoom();
    });
  }

  // ── Mobile scroll-snap sync (counter + dots follow native swipe) ──
  if (mobileGalleryEl) {
    var scrollSyncRaf = null;
    mobileGalleryEl.addEventListener('scroll', function() {
      if (suppressScrollSync) return;
      if (scrollSyncRaf) return;
      scrollSyncRaf = requestAnimationFrame(function() {
        scrollSyncRaf = null;
        var w = mobileGalleryEl.clientWidth;
        if (w <= 0) return;
        var idx = Math.round(mobileGalleryEl.scrollLeft / w);
        if (idx === currentImageIndex) return;
        var slideTotal = activeImages.length + (videoSlideNode ? 1 : 0);
        if (idx < 0 || idx >= slideTotal) return;
        // Pause the slide video when swiping away from it
        if (slideVideo && idx < activeImages.length && !slideVideo.paused) slideVideo.pause();
        currentImageIndex = idx;
        if (mobileCounter) mobileCounter.textContent = (idx + 1) + ' / ' + slideTotal;
        updateMobileDots(idx);
        if (typeof preloadAdjacent === 'function') preloadAdjacent();
      });
    }, { passive: true });
  }

  // ── Image preload cache for instant navigation ──
  var preloadedUrls = {};
  function preloadImage(url) {
    if (!url || preloadedUrls[url]) return;
    preloadedUrls[url] = true;
    var img = new Image();
    img.src = url;
  }
  function preloadAdjacent() {
    if (activeImages.length <= 1) return;
    var next = (currentImageIndex + 1) % activeImages.length;
    var prev = (currentImageIndex - 1 + activeImages.length) % activeImages.length;
    preloadImage(activeImages[next].src);
    preloadImage(activeImages[prev].src);
  }
  function preloadAllGallery() {
    for (var i = 0; i < activeImages.length; i++) {
      preloadImage(activeImages[i].src);
    }
  }

  // ── Initial gallery filter for the server-selected variant ──
  // Always rebuild so the Liquid-rendered thumbnails get click handlers attached.
  // For per-SKU products (no SKU-tagged alt text), fall back to all product images.
  var initialVariantId = PD.variantId;
  var initialFeatured = variants.find(function(v) { return v.id === initialVariantId; });
  // The hero Liquid actually rendered: `current_variant.image | default: product.featured_image`
  // (kc-product.liquid). product.featured_image is product.images[0] — verified across all
  // 830 active products. Only the initial render needs this fallback: on a variant switch
  // there is no server-rendered hero, and forcing images[0] in would show the wrong photo.
  var initialHero = (initialFeatured && initialFeatured.featured_image) ||
                    (allImages.length ? allImages[0] : null);
  activeImages = galleryFor(initialVariantId, initialHero);
  rebuildGallery(activeImages, initialFeatured ? initialFeatured.featured_image : null);

  // After page is idle, preload adjacent images first, then all gallery images
  var schedulePreload = window.requestIdleCallback || function(cb) { setTimeout(cb, 200); };
  schedulePreload(function() {
    preloadAdjacent();
    // Preload remaining images after a further delay to avoid competing with other resources
    setTimeout(preloadAllGallery, 1500);
  });

  // ── Desktop tabs ──
  document.querySelectorAll('[data-tab]').forEach(function(tab) {
    tab.addEventListener('click', function() {
      var target = this.dataset.tab;
      // Update tab bar styles
      document.querySelectorAll('[data-tab]').forEach(function(t) {
        t.classList.remove('bg-rb-ink', 'text-white');
        t.classList.add('text-rb-ink-mid');
        t.setAttribute('aria-selected', 'false');
      });
      this.classList.add('bg-rb-ink', 'text-white');
      this.classList.remove('text-rb-ink-mid');
      this.setAttribute('aria-selected', 'true');
      // Show/hide panels
      document.querySelectorAll('[data-tab-panel]').forEach(function(panel) {
        panel.style.display = (panel.dataset.tabPanel === target) ? '' : 'none';
      });
    });
  });

  // ── Read more / collapse ──
  if (readMoreBtn && aboutCollapse) {
    readMoreBtn.addEventListener('click', function() {
      aboutExpanded = !aboutExpanded;
      if (aboutExpanded) {
        aboutCollapse.style.maxHeight = 'none';
        if (aboutGradient) aboutGradient.style.display = 'none';
        readMoreBtn.textContent = 'Read less';
      } else {
        aboutCollapse.style.maxHeight = '480px';
        if (aboutGradient) aboutGradient.style.display = '';
        readMoreBtn.textContent = 'Read more';
      }
    });
  }

  // ── Mobile accordion ──
  document.querySelectorAll('[data-accordion-trigger]').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      var target = this.dataset.accordionTrigger;
      var content = document.querySelector('[data-accordion-content="' + target + '"]');
      var icon = this.querySelector('[data-accordion-icon]');
      var isOpen = this.getAttribute('aria-expanded') === 'true';

      this.setAttribute('aria-expanded', String(!isOpen));
      if (content) content.style.display = isOpen ? 'none' : '';
      if (icon) icon.classList.toggle('rotate-180', !isOpen);
    });
  });

  // ── Atelier Stack: accordion + state-line / chip updates ──
  (function initStack() {
    var stack = document.getElementById('kc-addon-stack');
    if (!stack) return;

    // Rows 01-03: toggle independently — clicked chevron stays put, panel drops below.
    stack.querySelectorAll('[data-stack-row]').forEach(function(row) {
      var head = row.querySelector('.kc-stack__head');
      var panel = row.querySelector('.kc-stack__expand');
      if (!head || !panel) return;
      // Row 04 (personalise) wires to the snippet's own panel — handled below.
      if (head.hasAttribute('data-stack-personalise-toggle')) return;
      head.addEventListener('click', function() {
        var open = row.classList.contains('is-open');
        row.classList.toggle('is-open', !open);
        head.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (open) panel.setAttribute('hidden', '');
        else panel.removeAttribute('hidden');
      });
    });

    // Row 04: our header drives the kc-product-mockup snippet's panel
    var personaliseHead = stack.querySelector('[data-stack-personalise-toggle]');
    if (personaliseHead) {
      var row = personaliseHead.closest('[data-stack-row]');
      var mockupPanel = document.getElementById('pdp-mockup-panel');
      personaliseHead.addEventListener('click', function() {
        if (!mockupPanel) return;
        var open = !mockupPanel.classList.contains('hidden');
        if (open) {
          mockupPanel.classList.add('hidden');
          row.classList.remove('is-open');
          personaliseHead.setAttribute('aria-expanded', 'false');
        } else {
          mockupPanel.classList.remove('hidden');
          row.classList.add('is-open');
          personaliseHead.setAttribute('aria-expanded', 'true');
        }
      });
    }

    // Radio changes → update row's state line + price chip
    stack.querySelectorAll('input[type="radio"][data-state-label]').forEach(function(r) {
      r.addEventListener('change', function() {
        if (!r.checked) return;
        var stateRow = r.closest('[data-stack-row]');
        if (!stateRow) return;
        var stateEl = stateRow.querySelector('[data-stack-state]');
        var chipEl = stateRow.querySelector('[data-stack-chip]');
        if (stateEl) stateEl.innerHTML = r.dataset.stateLabel || '';
        if (chipEl) {
          chipEl.textContent = r.dataset.chipText || '';
          chipEl.classList.remove('kc-stack__chip--free', 'kc-stack__chip--copper');
          if (r.dataset.chipTone === 'free') chipEl.classList.add('kc-stack__chip--free');
        }
      });
    });
  })();

  // ── Addon shelves (fetch + render + qty) ──
  var addonContainer = document.getElementById('addon-shelves');
  var addonCardsEl = document.getElementById('addon-shelf-cards');
  var addonFreeBadge = document.getElementById('addon-free-badge');
  var addonQtys = {}; // { vid: qty }
  var addonPrices = {}; // { vid: price float }
  var addonVids = []; // ordered list of variant IDs
  var addonImgs = {}; // { vid: { url, title } }

  function updateShelvingRowSummary() {
    var stateEl = document.getElementById('kc-shelving-state');
    var chipEl = document.getElementById('kc-shelving-chip');
    var total = 0, count = 0;
    for (var i = 0; i < addonVids.length; i++) {
      var q = addonQtys[addonVids[i]] || 0;
      if (q > 0) { total += q * (addonPrices[addonVids[i]] || 0); count += q; }
    }
    if (stateEl) {
      stateEl.textContent = count === 0
        ? 'Choose interior shelving'
        : count + (count === 1 ? ' shelf added' : ' shelves added');
    }
    if (chipEl) {
      chipEl.classList.remove('kc-stack__chip--free', 'kc-stack__chip--copper');
      chipEl.textContent = count === 0 ? 'Optional' : '+ $' + total.toFixed(0);
    }
  }

  function updateAddonSubtotal() {
    var total = 0, count = 0;
    for (var i = 0; i < addonVids.length; i++) {
      var q = addonQtys[addonVids[i]] || 0;
      if (q > 0) { total += q * (addonPrices[addonVids[i]] || 0); count += q; }
    }
    var stEl = document.getElementById('addon-subtotal');
    var stText = document.getElementById('addon-subtotal-text');
    if (count > 0 && stEl && stText) {
      stText.textContent = '+ $' + total.toFixed(0) + ' for ' + (count === 1 ? '1 shelf' : count + ' shelves');
      stEl.classList.remove('hidden');
    } else if (stEl) {
      stEl.classList.add('hidden');
    }
    updateShelvingRowSummary();
  }

  function refreshAddon(vid) {
    var q = addonQtys[vid] || 0;
    var qEl = document.getElementById('aq-' + vid);
    var cEl = document.getElementById('ac-' + vid);
    if (qEl) qEl.textContent = String(q);
    if (cEl) cEl.classList.toggle('is-selected', q > 0);
    updateAddonSubtotal();
  }

  if (addonContainer) {
    var handle = addonContainer.dataset.productHandle;
    fetch('/apps/kc/addons?handle=' + encodeURIComponent(handle))
      .then(function(r) { return r.ok ? r.json() : { addons: [] }; })
      .then(function(data) {
        var addons = data.addons || [];
        if (!addons.length) return;

        var cv = variants.find(function(v) { return v.id === parseInt(variantInput.value); });
        var productPrice = cv ? (cv.compare_at_price || cv.price) / 100 : 0;
        var shelvingCat = addons.find(function(a) { return a.id === 'shelving-upgrades'; });
        var hasFreeShelf = shelvingCat && shelvingCat.freeThreshold != null && productPrice >= shelvingCat.freeThreshold;

        // Build all cards as HTML, then inject once
        var html = '';
        for (var ci = 0; ci < addons.length; ci++) {
          var cat = addons[ci];
          for (var vi = 0; vi < cat.variants.length; vi++) {
            var v = cat.variants[vi];
            var vid = String(v.id);
            addonVids.push(vid);
            addonQtys[vid] = 0;
            addonPrices[vid] = parseFloat(v.price);
            var maxQ = v.maxQty || 4;

            var pLabel = '$' + parseFloat(v.price).toFixed(0);
            if (hasFreeShelf && cat.id === 'shelving-upgrades') {
              pLabel = '<span style="text-decoration:line-through;color:#999">$' + parseFloat(v.price).toFixed(0) + '</span> <span style="color:#059669;font-weight:700">FREE</span>';
            }

            addonImgs[vid] = { url: v.image || '', title: v.title, description: v.description || '' };
            var safeTitle = v.title.replace(/'/g, '&#39;').replace(/"/g, '&quot;');
            var thumbAttrs = v.image
              ? ' role="button" tabindex="0" aria-label="View larger image of ' + safeTitle + '"'
                + ' onclick="window._addonZoom(\'' + vid + '\')"'
                + ' onkeydown="if(event.key===\'Enter\'||event.key===\' \'){event.preventDefault();window._addonZoom(\'' + vid + '\')}"'
              : '';
            var zoomCue = v.image
              ? '<span class="kc-shelf-card__zoom" aria-hidden="true">'
                + '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>'
                + '</span>'
              : '';
            var descHtml = '';
            if (v.description) {
              var descSafe = v.description
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;');
              descHtml = '<p class="kc-shelf-card__desc">' + descSafe + '</p>';
            }
            // No image on the add-on product means no thumb column at all. Rendering
            // an empty .kc-shelf-card__thumb still claims its 120-140px track and
            // its 1:1 aspect-ratio, which stretched every card into a tall card
            // with a grey void where the photo should be.
            var thumbHtml = v.image
              ? '<div class="kc-shelf-card__thumb"' + thumbAttrs + '>'
                + '<img src="' + v.image + '" alt="' + safeTitle + '" loading="lazy">' + zoomCue
                + '</div>'
              : '';
            html += '<div id="ac-' + vid + '" class="kc-shelf-card'
              + (v.image ? '' : ' kc-shelf-card--noimg') + '">'
              + thumbHtml
              + '<div class="kc-shelf-card__body">'
              + '<div class="kc-shelf-card__top">'
              + '<div class="kc-shelf-card__title">' + v.title + '</div>'
              + descHtml
              + '</div>'
              + '<div class="kc-shelf-card__foot">'
              + '<div class="kc-shelf-card__price">' + pLabel + '</div>'
              + '<div class="kc-shelf-card__qty">'
              + '<button type="button" onclick="window._addonQty(\'' + vid + '\',-1,' + maxQ + ')" aria-label="Decrease quantity">\u2212</button>'
              + '<span id="aq-' + vid + '">0</span>'
              + '<button type="button" onclick="window._addonQty(\'' + vid + '\',1,' + maxQ + ')" aria-label="Increase quantity">+</button>'
              + '</div>'
              + '</div>'
              + '</div>'
              + '</div>';
          }
        }

        addonCardsEl.innerHTML = html;

        // Global click handler — simplest, most reliable pattern
        window._addonQty = function(vid, delta, maxQ) {
          var cur = addonQtys[vid] || 0;
          var next = cur + delta;
          if (next < 0 || next > maxQ) return;
          addonQtys[vid] = next;
          refreshAddon(vid);
        };

        // Click-to-zoom for addon thumbnails
        var addonZoomEl = document.getElementById('addon-zoom');
        var addonZoomImg = document.getElementById('addon-zoom-img');
        var addonZoomTitle = document.getElementById('addon-zoom-title');
        var addonZoomDesc = document.getElementById('addon-zoom-desc');
        function closeAddonZoom() {
          if (!addonZoomEl) return;
          addonZoomEl.style.opacity = '0';
          setTimeout(function() { addonZoomEl.style.display = 'none'; }, 200);
          document.body.style.overflow = '';
        }
        window._addonZoom = function(vid) {
          var rec = addonImgs[vid];
          if (!rec || !rec.url || !addonZoomEl) return;
          addonZoomImg.src = rec.url;
          addonZoomImg.alt = rec.title || '';
          if (addonZoomTitle) addonZoomTitle.textContent = rec.title || '';
          if (addonZoomDesc) {
            addonZoomDesc.textContent = rec.description || '';
            addonZoomDesc.style.display = rec.description ? 'block' : 'none';
          }
          addonZoomEl.style.display = 'flex';
          // force reflow so the opacity transition runs
          void addonZoomEl.offsetWidth;
          addonZoomEl.style.opacity = '1';
          document.body.style.overflow = 'hidden';
        };
        if (addonZoomEl) {
          addonZoomEl.addEventListener('click', function(e) {
            if (e.target === addonZoomEl || e.target.dataset.addonZoomDismiss) closeAddonZoom();
          });
          document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && addonZoomEl.style.display === 'flex') closeAddonZoom();
          });
        }

        addonContainer.classList.remove('hidden');
        if (hasFreeShelf) addonFreeBadge.classList.remove('hidden');
        // Reveal the Shelving row now that cards exist
        var shelvingRow = document.getElementById('kc-stack-row-shelving');
        if (shelvingRow) shelvingRow.removeAttribute('hidden');
        updateShelvingRowSummary();
      })
      .catch(function() { /* silent — shelves just don't appear */ });
  }

  // ── ATC via AJAX (with addon shelves) ──
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var id = parseInt(variantInput.value);
      if (!id || atcBtn.disabled) return;

      atcBtn.textContent = 'ADDING...';
      atcBtn.disabled = true;

      // Build items array: main product + any selected addon shelves
      // Optional quantity input (PDP v2 only); absent on control = 1
      var qtyEl = document.getElementById('kc-qty-input');
      var mainItem = { id: id, quantity: Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1) };
      // Proposal reconciliation: a customer who arrives from a /branded/<slug>
      // proposal carries ?ref=<deal-slug> (+ optional ?design=<id>). Stamp them
      // as hidden (_-prefixed) line properties so the orders/create webhook can
      // link the paid order back to its kc_deals proposal. Hidden from the
      // customer at checkout; visible to ops in the Shopify admin order.
      var dealProps = {};
      try {
        var dealQs = new URLSearchParams(window.location.search);
        var dealRef = dealQs.get('ref');
        var dealDesign = dealQs.get('design');
        if (dealRef) dealProps['_deal_slug'] = dealRef;
        if (dealDesign) dealProps['_deal_design'] = dealDesign;
      } catch (e) { /* URLSearchParams unsupported — skip stamping */ }
      // Custom Branded design properties (hidden inputs, only present on custom-branded PDPs)
      var cbProps = {};
      ['cb-prop-brand', 'cb-prop-logo-file', 'cb-prop-logo-url', 'cb-prop-notes'].forEach(function(propId) {
        var el = document.getElementById(propId);
        if (el && el.value) {
          var key = (el.name || '').replace(/^properties\[|\]$/g, '');
          if (key) cbProps[key] = el.value;
        }
      });
      if (Object.keys(cbProps).length > 0) mainItem.properties = cbProps;
      // Licensed multi-design fridges (snippets/kc-design-picker.liquid): the chosen
      // door artwork rides on the fridge line. The picker's hidden properties[Design]
      // input never reached the cart on its own, because this handler builds the
      // payload by hand.
      var designInput = form.querySelector('[data-kc-design-input]');
      if (designInput && designInput.value) {
        mainItem.properties = mainItem.properties || {};
        mainItem.properties['Design'] = designInput.value;
      }
      // Personalised text (number plate / custom name): the submit handler
      // builds the payload manually, so named inputs don't ride along on
      // their own. Blank = customer wants the default design. Every field is
      // sent: custom.personalise_labels can render up to three (Retro Golf asks
      // for a name and a year).
      form.querySelectorAll('[data-personalise-input]').forEach(function(persInput) {
        if (!persInput.value.trim()) return;
        var persKey = (persInput.name || '').replace(/^properties\[|\]$/g, '');
        if (persKey) {
          mainItem.properties = mainItem.properties || {};
          mainItem.properties[persKey] = persInput.value.trim();
        }
      });
      // Always carry the deal ref on the main line (present even if the wrap
      // is deselected) so the proposal can be reconciled from any order line.
      if (Object.keys(dealProps).length) {
        mainItem.properties = mainItem.properties || {};
        for (var dk in dealProps) mainItem.properties[dk] = dealProps[dk];
      }
      // Door hinge on the FREE tier (iXP1-840-R): BFA sells no hinge change for
      // that model, so there is nothing to charge and nothing to resolve to a
      // variant. The addon loop below bails on any radio without a variant id
      // (`if (!vid) return;`), which would drop the customer's choice silently
      // and ship the fridge right-hinged. Stamp it on the fridge line instead.
      // Gated on data-hinge-free, present only on the free CHANGE option - the
      // "Comes Right" default has no such attribute, so the ~50 paid-tier PDPs
      // keep their existing behaviour and gain no property.
      var hingeFreeEl = document.querySelector('input[name="kc-hinge-side"][data-hinge-free]:checked');
      if (hingeFreeEl && hingeFreeEl.dataset.stateLabel) {
        mainItem.properties = mainItem.properties || {};
        mainItem.properties[hingeFreeEl.dataset.addonProperty || 'Door Hinge'] = hingeFreeEl.dataset.stateLabel;
      }
      var items = [mainItem];
      // Free bar mat (licensed uprights): the block only renders while the
      // promo tag is on the fridge, and the automatic discount takes the mat to
      // $0 at checkout. Absent block = unchanged behaviour.
      var freeMatEl = document.getElementById('kc-free-mat');
      var freeMatVid = freeMatEl ? parseInt(freeMatEl.dataset.freeMatVariant) : 0;
      if (freeMatVid) {
        items.push({ id: freeMatVid, quantity: 1, properties: { '_kc_promo': 'free-mat' } });
      }
      // Paid matching mat (other licensed fridges): only when the customer ticks it.
      var addonMatEl = document.getElementById('kc-addon-mat-check');
      if (addonMatEl && addonMatEl.checked && parseInt(addonMatEl.value)) {
        items.push({ id: parseInt(addonMatEl.value), quantity: 1, properties: { 'For': PD.title } });
      }
      Object.keys(addonQtys).forEach(function(vid) {
        var qty = addonQtys[vid];
        if (qty > 0) {
          items.push({ id: parseInt(vid), quantity: qty });
        }
      });

      // Dropdown addons (warranty, old fridge removal): push selected variant + link to parent
      var parentTitle = PD.title;
      // Atelier Stack radios — warranty + delivery/removal
      document.querySelectorAll('input[type="radio"][data-addon-property]:checked').forEach(function(r) {
        var vid = r.dataset.variantId;
        if (!vid) return; // "included / no thanks" option has no variant id
        var addonProps = { 'For': parentTitle };
        for (var dk2 in dealProps) addonProps[dk2] = dealProps[dk2];
        // Logo wrap add-on carries the design capture (brand/logo/notes) on
        // its own line so ops can route the order to the wrap workflow.
        if (r.name === 'kc-logo' && window.kcLogoAddonProps) {
          var logoProps = window.kcLogoAddonProps();
          for (var lk in logoProps) {
            if (logoProps[lk]) addonProps[lk] = logoProps[lk];
          }
        }
        // Door hinge swap carries the DIRECTION on the line. The $15 tier bakes
        // it into the variant (DOOR_HINGE_LEFT), but the $99 upright variant is
        // shared by models that ship right-hinged and models that ship left, so
        // the variant alone does not tell the workshop which way to re-hang the
        // door. Without this the order is ambiguous on 3 of the 9 upright SKUs.
        if (r.name === 'kc-hinge-side' && r.dataset.stateLabel) {
          addonProps[r.dataset.addonProperty || 'Door Hinge'] = r.dataset.stateLabel;
        }
        items.push({
          id: parseInt(vid),
          quantity: 1,
          properties: addonProps
        });
      });

      // Delivery timing + instructions \u2192 order-level cart note, merged with
      // whatever note the cart already holds (see kcComposeNote).
      var deliveryNotesEl = document.getElementById('kc-delivery-notes');
      var deliveryNote = deliveryNotesEl ? deliveryNotesEl.value.trim() : '';
      var requestedWeek = kcRequestedWeek();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function(res) {
          if (!res.ok) throw new Error('Failed');
          return res.json();
        })
        .then(function(added) {
          var addedItems = (added && added.items) || [];
          if (window.kcCapture && addedItems.length) {
            window.kcCapture('kc_add_to_cart', {
              sku: addedItems[0].sku || '',
              price: (addedItems[0].final_price || addedItems[0].price || 0) / 100,
              addons: addedItems.length - 1
            });
          }
          atcBtn.textContent = 'ADDED \u2713';
          setTimeout(function() {
            atcBtn.textContent = 'Add to Cart';
            atcBtn.disabled = false;
          }, 1500);
          var showCart = function(cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
            document.dispatchEvent(new CustomEvent('cart:open'));
          };
          fetch('/cart.js', { credentials: 'same-origin' })
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              var note = kcComposeNote(cart.note, requestedWeek, deliveryNote);
              if (note === (cart.note || '')) return cart;
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ note: note })
              })
                .then(function(r) { if (!r.ok) throw new Error('note'); return r.json(); })
                .catch(function() { return cart; });
            })
            .then(showCart)
            .catch(function() {});
        })
        .catch(function() {
          atcBtn.textContent = 'ERROR \u2014 TRY AGAIN';
          setTimeout(function() {
            atcBtn.textContent = 'Add to Cart';
            atcBtn.disabled = false;
          }, 2000);
        });
    });
  }

  // ── PDP wrapper height: keep absolute-positioned buybox inside its wrapper ──
  // The buybox uses lg:absolute to fake a two-column layout (lg:pr-[45%] on the
  // wrapper). When the buybox is expanded — Personalise especially — it can
  // grow taller than column 1 and visually overflow into the See-It-Styled
  // section below. Mirror its height onto the wrapper so the next section
  // always starts below it.
  (function pdpWrapperHeight() {
    var wrapper = document.querySelector('[data-section-product] > div.lg\\:relative');
    if (!wrapper) return;
    var buyboxCol = wrapper.querySelector(':scope > .lg\\:absolute');
    if (!buyboxCol) return;
    var mq = window.matchMedia('(min-width: 1024px)');

    function adjust() {
      if (!mq.matches) { wrapper.style.minHeight = ''; return; }
      wrapper.style.minHeight = buyboxCol.offsetHeight + 'px';
    }

    var pending;
    function schedule() {
      cancelAnimationFrame(pending);
      pending = requestAnimationFrame(adjust);
    }

    schedule();
    window.addEventListener('resize', schedule);
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', schedule);

    if (window.ResizeObserver) {
      new ResizeObserver(schedule).observe(buyboxCol);
    } else {
      document.querySelectorAll('.kc-stack__head').forEach(function(b) {
        b.addEventListener('click', function() { setTimeout(schedule, 350); });
      });
    }
  })();

  // ── Delivery timing helpers (shared by the delivery row and add-to-cart) ──
  var KC_WEEK_DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var KC_WEEK_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var KC_TIMING_PREFIX = 'Requested delivery:';
  // "Mon 9 Nov" for the customer; "Mon 9 Nov 2026" on the order, where a
  // January week must not be read as this January.
  function kcFormatWeek(d, withYear) {
    return KC_WEEK_DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + KC_WEEK_MONTHS[d.getMonth()]
      + (withYear ? ' ' + d.getFullYear() : '');
  }
  // The requested week, or null when the customer wants it as soon as possible.
  function kcRequestedWeek() {
    var picked = document.querySelector('input[name="kc-dlv-timing"]:checked');
    var sel = document.getElementById('kc-dlv-week');
    if (!picked || picked.value !== 'week' || !sel || !sel.value) return null;
    var opt = sel.options[sel.selectedIndex];
    return { full: sel.value, short: opt ? opt.textContent.replace(/^Week of /, '') : sel.value };
  }
  // Order note = timing line first, then instructions. Instructions typed on
  // the PDP replace the old ones, as before; left blank, the existing ones
  // (perhaps typed in the cart drawer) are kept. A new week replaces an old
  // timing line. "As soon as possible" is the default, so it cannot tell
  // "chose ASAP" from "did not touch it", and leaves an earlier request alone.
  function kcComposeNote(existing, week, instructions) {
    var lines = String(existing || '').split('\n');
    var oldTiming = '';
    var rest = [];
    for (var i = 0; i < lines.length; i++) {
      if (lines[i].indexOf(KC_TIMING_PREFIX) === 0) oldTiming = lines[i];
      else rest.push(lines[i]);
    }
    var timing = week ? KC_TIMING_PREFIX + ' week of ' + week.full : oldTiming;
    var body = instructions || rest.join('\n').trim();
    return [timing, body].filter(Boolean).join('\n');
  }

  // ── Delivery & Removal: postcode-gate (legacy standalone widget removed) ──
  (function initRemovalGate() {
    var COOKIE = 'kc_postcode';
    var filledEl = document.querySelector('[data-removal-filled]');
    var input = document.getElementById('kc-removal-postcode');
    var submitBtn = document.getElementById('kc-removal-submit');
    var formEl = document.getElementById('kc-removal-form');
    var errEl = document.getElementById('kc-removal-error');
    if (!filledEl || !input || !submitBtn || !formEl) return;
    var SUBMIT_LABEL = submitBtn.textContent;

    // Fire pits: one freight line, no service choice.
    var freightPcEl = filledEl.querySelector('[data-freight-pc]');
    var freightPriceEl = filledEl.querySelector('[data-freight-price]');
    var freightMetaEl = filledEl.querySelector('[data-freight-meta]');

    // Everything else: the consignment label, and the install tick that
    // drives the two hidden kc-removal radios the cart and row header read.
    var radios = {
      standard: filledEl.querySelector('input[name="kc-removal"][data-tile="standard"]'),
      inside: filledEl.querySelector('input[name="kc-removal"][data-tile="inside"]')
    };
    var labelEls = {
      total: filledEl.querySelector('[data-dlv-total]'),
      to: filledEl.querySelector('[data-dlv-to]'),
      when: filledEl.querySelector('[data-dlv-when]')
    };
    var installRow = filledEl.querySelector('[data-dlv-install]');
    var installToggle = filledEl.querySelector('[data-dlv-install-toggle]');
    var installWhenEl = filledEl.querySelector('[data-dlv-install-when]');
    // The last quote, so the install tick repaints without a refetch.
    var view = null;

    // Inside-delivery service fee, rendered from the height tier ($225, or $275
    // for 1800mm and up) so theme and Shopify stay in sync.
    var INSIDE_SERVICE_FEE = PD.insideServiceFee;

    var rowEl = document.querySelector('[data-stack-row="removal"]');
    var rowState = rowEl && rowEl.querySelector('[data-stack-state]');
    var rowChip = rowEl && rowEl.querySelector('[data-stack-chip]');

    var currentSku = PD.sku;

    function getCookie() {
      var m = document.cookie.match(new RegExp('(?:^|; )' + COOKIE + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    }
    function setCookie(pc) {
      document.cookie = COOKIE + '=' + encodeURIComponent(pc) + ';path=/;max-age=31536000;SameSite=Lax';
    }
    function isValidPC(pc) { return /^[0-9]{4}$/.test(pc); }

    // Postcode → AU state (sufficient resolution for inside-delivery availability)
    function stateFromPC(pc) {
      var n = parseInt(pc, 10);
      if ((n >= 1000 && n <= 1999) || (n >= 2000 && n <= 2599) || (n >= 2619 && n <= 2899) || (n >= 2921 && n <= 2999)) return 'NSW';
      if ((n >= 200 && n <= 299) || (n >= 2600 && n <= 2618) || (n >= 2900 && n <= 2920)) return 'ACT';
      if ((n >= 3000 && n <= 3999) || (n >= 8000 && n <= 8999)) return 'VIC';
      if ((n >= 4000 && n <= 4999) || (n >= 9000 && n <= 9999)) return 'QLD';
      if (n >= 5000 && n <= 5999) return 'SA';
      if ((n >= 6000 && n <= 6797) || (n >= 6800 && n <= 6999)) return 'WA';
      if (n >= 7000 && n <= 7999) return 'TAS';
      if ((n >= 800 && n <= 899) || (n >= 900 && n <= 999)) return 'NT';
      return '';
    }
    var INSIDE_DELIVERY_STATES = { VIC: 1, NSW: 1, QLD: 1 };

    function syncButton() { submitBtn.disabled = !isValidPC(input.value); }

    function renderError(msg) {
      if (!errEl) return;
      errEl.textContent = msg;
      errEl.classList.remove('hidden');
    }
    function clearError() {
      if (!errEl) return;
      errEl.textContent = '';
      errEl.classList.add('hidden');
    }

    // Pre-order or sold out: nothing ships today, so a date counted from today
    // would be a promise we cannot keep (JB, 30 Sep 2026). Same test as the
    // stock badge: tracked stock at or below zero, or not available at all.
    // A SKU missing from the variants JSON is treated as in stock, which is
    // what the page did before this check existed.
    var variantsBySku = {};
    try {
      JSON.parse(document.getElementById('product-variants-json').textContent).forEach(function(v) {
        if (v.sku) variantsBySku[v.sku] = v;
      });
    } catch (e) { variantsBySku = {}; }
    function shipsToday() {
      // Vinyl-wrapped fridges are wrapped after the order: 5 working days
      // before dispatch (snippets/kc-wrap-lead.liquid), so transit runs from
      // dispatch, never from today.
      if (PD.wrapLead) return false;
      var v = variantsBySku[currentSku];
      if (!v) return true;
      if (!v.available) return false;
      return !(v.inventory_management === 'shopify' && v.inventory_quantity <= 0);
    }

    // JB, 5 Oct 2026: no calendar dates. They kept missing, so the label says
    // the range and nothing more: "3 to 5 working days" -> "Arrives 3 to 5
    // working days". When the variant cannot ship today the range runs from
    // dispatch instead. Null when the server sent no parseable range, so the
    // caller falls back.
    function arrivalWindow(days) {
      var m = /(\d+)\s*to\s*(\d+)/.exec(days || '');
      if (!m) return null;
      var range = m[1] + ' to ' + m[2] + ' working days';
      return shipsToday()
        ? { label: 'Arrives ' + range }
        : { label: 'Delivery ' + range + ' after dispatch' };
    }
    // Show cents when the quote has them: checkout charges the exact figure, so $59.95 must not read as $60.
    function money(n) { return n === 0 ? 'Free' : '$' + (n % 1 ? n.toFixed(2) : n.toFixed(0)); }

    function flip(el, text) {
      if (!el) return;
      if (el.textContent !== text) {
        el.classList.remove('kc-dlv-flip');
        void el.offsetWidth;
        el.classList.add('kc-dlv-flip');
      }
      el.textContent = text;
    }

    // Paint the label for the ticked option and check the matching radio, so
    // the cart line and the row header follow it.
    function paintLabel() {
      if (!view) return;
      var inst = !!(installToggle && installToggle.checked && installRow && !installRow.hidden);
      var opt = inst ? view.inside : view.express;
      flip(labelEls.total, opt.total);
      var week = kcRequestedWeek();
      flip(labelEls.when, week ? 'Week of ' + week.short : opt.when);
      var r = inst ? radios.inside : radios.standard;
      if (!r) return;
      r.checked = true;
      r.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (installToggle) installToggle.addEventListener('change', paintLabel);

    // Delivery timing: "As soon as possible" or a requested week. Mondays from
    // at least ten days out, so a chosen week never means the same as ASAP, to
    // the last Monday within six weeks of today: KC can hold stock for six
    // weeks and no longer (JB, 16 Oct 2026). The ATC handler writes the
    // choice to cart.note.
    (function initTiming() {
      var HOLD_DAYS = 42;
      var weekWrap = filledEl.querySelector('[data-dlv-week-wrap]');
      var weekSel = document.getElementById('kc-dlv-week');
      var timingRadios = filledEl.querySelectorAll('input[name="kc-dlv-timing"]');
      if (!weekWrap || !weekSel || !timingRadios.length) return;
      var d = new Date();
      d.setHours(0, 0, 0, 0);
      var last = new Date(d);
      last.setDate(last.getDate() + HOLD_DAYS);
      d.setDate(d.getDate() + 10);
      while (d.getDay() !== 1) d.setDate(d.getDate() + 1);
      while (d <= last) {
        var o = document.createElement('option');
        o.value = kcFormatWeek(d, true);
        o.textContent = 'Week of ' + kcFormatWeek(d, false);
        weekSel.appendChild(o);
        d.setDate(d.getDate() + 7);
      }
      function sync() {
        var picked = filledEl.querySelector('input[name="kc-dlv-timing"]:checked');
        weekWrap.hidden = !picked || picked.value !== 'week';
        if (radios.standard) paintLabel();
      }
      for (var j = 0; j < timingRadios.length; j++) timingRadios[j].addEventListener('change', sync);
      weekSel.addEventListener('change', sync);
    })();

    function applyQuote(pc, rate, delivery) {
      var state = stateFromPC(pc);
      // Defensive: Number(undefined) -> NaN; Number(null) -> 0. Coerce to 0 on bad input.
      var rawPrice = Number(rate && rate.price);
      var price = isFinite(rawPrice) ? rawPrice : 0;
      var isFree = price === 0;
      var freightCopy = money(price);
      // Transit comes from the server, which returns the checkout's own figure
      // for this postcode and SKU. Falls back only if the server sends nothing.
      var std = delivery && delivery.standard;
      var days = (std && std.days) ? std.days : '3 to 5 working days';
      var stdWin = arrivalWindow(days);
      var stdLabel = stdWin ? stdWin.label : days;

      // Fire pit: no service choice, one line.
      if (freightPcEl) freightPcEl.textContent = pc;
      if (freightPriceEl) freightPriceEl.textContent = freightCopy;
      if (freightMetaEl) freightMetaEl.textContent = stdLabel;

      // Every order is express, installed or not (JB, 1 Oct 2026): one window.
      var INSIDE_DAYS = days;
      var insWin = arrivalWindow(INSIDE_DAYS);
      function cellText(win, d) { return win ? win.label.replace(/^(Arrives|Delivery) /, '') : d; }
      var insideTotal = money(price + INSIDE_SERVICE_FEE);

      if (labelEls.to) labelEls.to.textContent = state ? pc + ' ' + state : pc;
      var insideOk = !!INSIDE_DELIVERY_STATES[state];
      if (installRow) installRow.hidden = !insideOk;
      if (!insideOk && installToggle) installToggle.checked = false;
      if (installWhenEl) installWhenEl.textContent = insWin ? insWin.label + '.' : '';

      // Row header: JB, 1 Oct 2026, "Express, arrives in 3-5 working days".
      if (radios.standard) {
        radios.standard.dataset.stateLabel = 'Express, arrives in ' + days.replace(' to ', '-');
        radios.standard.dataset.chipText = freightCopy;
        radios.standard.dataset.chipTone = isFree ? 'free' : 'neutral';
      }
      if (radios.inside) {
        radios.inside.dataset.stateLabel = 'Installed, ' + (insWin
          ? insWin.label.charAt(0).toLowerCase() + insWin.label.slice(1)
          : 'arrives in ' + INSIDE_DAYS.replace(' to ', '-'));
        radios.inside.dataset.chipText = insideTotal;
      }

      view = {
        express: { total: freightCopy, when: cellText(stdWin, days) },
        inside: { total: insideTotal, when: cellText(insWin, INSIDE_DAYS) }
      };

      // Fire pits have no label and no radios: their header takes the
      // freight and transit directly.
      if (radios.standard) paintLabel();
      else if (rowState) {
        rowState.textContent = stdLabel;
        if (rowChip) {
          rowChip.textContent = freightCopy;
          rowChip.classList.toggle('kc-stack__chip--free', isFree);
        }
      }
      if (rowChip) {
        rowChip.classList.remove('kc-stack__chip--copper');
        rowChip.classList.add('kc-stack__chip--total');
      }

      filledEl.removeAttribute('hidden');
      clearError();
    }

    // The quote event carries the postcode, the rate and the days (JB 24 Oct:
    // "track who is checking, and who ends up converting"). A postcode alone
    // identifies nobody, and PostHog already records an IP-derived one.
    function kcStateFromPostcode(pc) {
      var n = parseInt(pc, 10);
      if (n >= 200 && n <= 299) return 'ACT';
      if (n >= 2600 && n <= 2618) return 'ACT';
      if (n >= 2900 && n <= 2920) return 'ACT';
      if (n >= 800 && n <= 999) return 'NT';
      var first = String(pc).charAt(0);
      return { '1': 'NSW', '2': 'NSW', '3': 'VIC', '4': 'QLD', '5': 'SA', '6': 'WA', '7': 'TAS', '8': 'VIC', '9': 'QLD' }[first] || 'unknown';
    }

    function kcTrackQuote(pc, price, delivery) {
      try {
        if (!window.kcCapture) return;
        window.kcCapture('kc_delivery_quote', {
          sku: currentSku,
          ok: price !== null,
          state: kcStateFromPostcode(pc),
          postcode: pc,
          price: price,
          days: (delivery && delivery.standard && delivery.standard.days) || ''
        });
      } catch (e) { /* analytics must never break the quote */ }
    }

    function fetchQuote(pc) {
      if (!currentSku || !isValidPC(pc)) return;
      submitBtn.textContent = '...';
      submitBtn.disabled = true;
      clearError();
      fetch('/apps/kc/shipping/quote', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ sku: currentSku, quantity: 1 }], postcode: pc })
      })
        .then(function(res) { if (!res.ok) throw new Error('Failed'); return res.json(); })
        .then(function(data) {
          setCookie(pc);
          var rate = data && data.rate ? Number(data.rate.price) : NaN;
          kcTrackQuote(pc, isFinite(rate) ? rate : null, data && data.delivery);
          if (data && data.rate) applyQuote(pc, data.rate, data.delivery);
          else renderError('Shipping not available to ' + pc + '. Please contact us for a quote.');
        })
        .catch(function() {
          kcTrackQuote(pc, null, null);
          renderError('Unable to estimate shipping. Please try again.');
        })
        .finally(function() {
          submitBtn.textContent = SUBMIT_LABEL;
          syncButton();
        });
    }

    input.addEventListener('input', function() {
      this.value = this.value.replace(/\D/g, '').slice(0, 4);
      syncButton();
    });

    formEl.addEventListener('submit', function(e) {
      e.preventDefault();
      fetchQuote(input.value);
    });

    // Pre-fill from cookie + auto-fetch on load
    var saved = getCookie();
    if (saved && isValidPC(saved)) {
      input.value = saved;
      syncButton();
      fetchQuote(saved);
    }

    // Re-fetch on variant change so SKU-specific freight stays accurate
    window.addEventListener('variant:change', function(e) {
      var detail = e.detail || {};
      if (detail.sku) {
        currentSku = detail.sku;
        var pc = getCookie();
        if (isValidPC(pc)) fetchQuote(pc);
      }
    });
  })();

  // ── FAQ accordion (variant-aware) ──
  var faqContainer = document.getElementById('product-faqs');
  var faqList = document.getElementById('faq-list');
  var faqListDesktop = document.getElementById('faq-list-desktop');
  var faqSectionWrapper = document.getElementById('faq-section-wrapper');
  var faqSectionCount = document.getElementById('kc-faq-section-count');
  var faqTabBtn = document.getElementById('kc-tab-faq');
  var faqTabCount = document.getElementById('kc-tab-faq-count');
  var faqData = {};
  try { faqData = JSON.parse(document.getElementById('variant-faqs-json').textContent); } catch(e) {}

  function setFaqSectionCount(n) {
    if (faqSectionCount) faqSectionCount.textContent = n > 0 ? ' (' + n + ')' : '';
    if (faqTabCount) faqTabCount.textContent = n > 0 ? ' (' + n + ')' : '';
  }

  function bindFaqAccordion(root) {
    if (!root) return;
    root.querySelectorAll('[data-faq-trigger]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var isOpen = this.getAttribute('aria-expanded') === 'true';
        var answer = this.parentElement.querySelector('[data-faq-answer]');
        var icon = this.querySelector('[data-faq-icon]');
        this.setAttribute('aria-expanded', String(!isOpen));
        if (answer) answer.style.maxHeight = isOpen ? '0' : answer.scrollHeight + 'px';
        if (icon) icon.classList.toggle('rotate-180', !isOpen);
      });
    });
  }

  function renderFaqs(faqs) {
    if (!faqs || !faqs.length) {
      if (faqSectionWrapper) faqSectionWrapper.style.display = 'none';
      if (faqTabBtn) faqTabBtn.classList.add('hidden');
      if (faqList) faqList.innerHTML = '';
      if (faqListDesktop) faqListDesktop.innerHTML = '';
      setFaqSectionCount(0);
      return;
    }
    if (faqSectionWrapper) faqSectionWrapper.style.display = '';
    if (faqTabBtn) faqTabBtn.classList.remove('hidden');
    setFaqSectionCount(faqs.length);
    var html = '';
    faqs.forEach(function(faq) {
      html += '<div class="border-b border-rb-rule-light">'
        + '<button type="button" class="flex w-full items-center justify-between py-4 text-left cursor-pointer bg-transparent border-none" data-faq-trigger aria-expanded="false">'
        + '<span class="font-mono text-[13px] font-bold text-rb-ink pr-4">' + faq.question + '</span>'
        + '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="shrink-0 transition-transform duration-200" data-faq-icon aria-hidden="true"><path d="M6 9l6 6 6-6"></path></svg>'
        + '</button>'
        + '<div class="overflow-hidden transition-[max-height] duration-200 ease-in-out" style="max-height:0" data-faq-answer>'
        + '<p class="font-mono text-[13px] leading-[1.7] text-rb-ink-mid pb-4">' + faq.answer + '</p>'
        + '</div></div>';
    });
    if (faqList) faqList.innerHTML = html;
    if (faqListDesktop) faqListDesktop.innerHTML = html;
    if (faqContainer) faqContainer.style.display = '';
    bindFaqAccordion(faqList);
    bindFaqAccordion(faqListDesktop);
  }

  // Initial render — selected variant or product fallback
  var initialVariantId = variantInput ? variantInput.value : null;
  renderFaqs(faqData[initialVariantId] || faqData['_product'] || null);

  // Swap on variant change
  window.addEventListener('variant:change', function(e) {
    var vid = e.detail && e.detail.id;
    renderFaqs(faqData[vid] || faqData['_product'] || null);
  });

  // ── Judge.me widget: shared between desktop tab + mobile accordion (move on demand) ──
  // Single DOM node for #judgeme_product_reviews, moved into whichever container
  // is currently active so we never have duplicate IDs. The review count in the
  // tab and accordion labels is rendered server-side.
  (function() {
    var widget = document.getElementById('judgeme_product_reviews');
    var desktopHost = document.getElementById('kc-reviews-desktop-host');
    var mobilePanel = document.getElementById('reviews-section-panel');
    if (!widget || !desktopHost || !mobilePanel) return;
    var mql = window.matchMedia('(min-width: 768px)');
    function placeWidget() {
      var target = mql.matches ? desktopHost : mobilePanel;
      if (widget.parentNode !== target) target.appendChild(widget);
    }
    placeWidget();
    if (mql.addEventListener) mql.addEventListener('change', placeWidget);
    else if (mql.addListener) mql.addListener(placeWidget);
  })();

  // ── Share button ──
  document.querySelectorAll('[data-share-btn]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (navigator.share) {
        navigator.share({ title: PD.title, url: window.location.href });
      } else {
        navigator.clipboard.writeText(window.location.href).then(function() {
          btn.setAttribute('title', 'Link copied!');
          setTimeout(function() { btn.setAttribute('title', 'Share'); }, 2000);
        });
      }
    });
  });

  // ── Speak with Expert → opens Intercom ──
  var conciergeBtn = document.querySelector('[data-concierge-btn]');
  if (conciergeBtn) {
    conciergeBtn.addEventListener('click', function() {
      var sku = desktopSku ? desktopSku.textContent.trim() : '';
      var title = PD.title;
      var msg = 'Hi, I\'m looking at ' + title + (sku ? ' (' + sku + ')' : '');
      window.kcIntercom('showNewMessage', msg);
    });
  }

  // ── "Need a Different Size?" (branded designs) → opens Intercom pre-filled ──
  // Delegated: the capacity-row link is rebuilt by updateSpecs() on variant change.
  document.addEventListener('click', function(e) {
    if (!e.target.closest('[data-size-swap-ask]')) return;
    var sku = desktopSku ? desktopSku.textContent.trim() : '';
    var title = PD.title;
    var msg = 'Hi, I\'m looking at the ' + title + (sku ? ' (' + sku + ')' : '') + ' \u2014 can I get this design on a different size?';
    window.kcIntercom('showNewMessage', msg);
  });

  // Show notify-me if initial variant is sold out
  if (!PD.available) {
    if (notifyWrap) notifyWrap.classList.remove('hidden');
  }

});

  (function() {
    'use strict';
    var dropEl = document.getElementById('kc-logo-drop');
    var fileInput = document.getElementById('kc-logo-file');
    var labelEl = document.getElementById('kc-logo-label');
    var businessEl = document.getElementById('kc-logo-business');
    var notesEl = document.getElementById('kc-logo-notes');
    var detailsEl = document.getElementById('kc-logo-details');
    var yesRadio = document.getElementById('kc-logo-radio-yes');
    var form = document.getElementById('product-form');
    var atcBtn = document.getElementById('add-to-cart-btn');
    if (!yesRadio || !form) return;

    /* The upload (assets/kc-upload.js) is attached when the row renders a drop
       zone, which the build card does (snippets/kc-cb-addon-row.liquid). The
       signed-URL path to the kc-uploads bucket was re-verified live on
       5 Oct 2026. Without it the uploader is a no-op and the order still goes
       through; the logo is then collected after checkout. */
    var noopUploader = { getLogoUrl: function() { return null; }, getLogoFilename: function() { return null; }, isUploading: function() { return false; }, reset: function() {} };
    var uploader = (dropEl && fileInput && labelEl && window.kcAttachLogoUpload)
      ? window.kcAttachLogoUpload({ dropEl: dropEl, fileInput: fileInput, labelEl: labelEl })
      : noopUploader;

    /* Design capture fields only make sense once the wrap is selected. */
    var cardEl = document.getElementById('kc-cbr-card');
    function syncDetails() {
      if (detailsEl) {
        if (yesRadio.checked) detailsEl.removeAttribute('hidden');
        else detailsEl.setAttribute('hidden', '');
      }
      if (cardEl) cardEl.classList.toggle('is-on', yesRadio.checked);
    }

    /* Drag and drop onto the build card's upload area. kcAttachLogoUpload
       only listens for click and the input's change event, so a dropped
       file is handed to the input and the same change path uploads it. */
    if (dropEl && fileInput) {
      ['dragenter', 'dragover'].forEach(function(evName) {
        dropEl.addEventListener(evName, function(ev) { ev.preventDefault(); dropEl.classList.add('is-over'); });
      });
      dropEl.addEventListener('dragleave', function() { dropEl.classList.remove('is-over'); });
      dropEl.addEventListener('drop', function(ev) {
        ev.preventDefault();
        dropEl.classList.remove('is-over');
        var dt = ev.dataTransfer;
        if (!dt || !dt.files || !dt.files.length) return;
        try { fileInput.files = dt.files; } catch (e) { return; }
        fileInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    document.querySelectorAll('input[name="kc-logo"]').forEach(function(r) {
      r.addEventListener('change', syncDetails);
    });
    syncDetails();

    /* Add-on line-item props. Falls back to kcProposalPrefill (logo we already
       hold from the proposal) when the customer hasn't uploaded a new file. */
    window.kcLogoAddonProps = function() {
      var pf = window.kcProposalPrefill || {};
      return {
        'Brand Name': (businessEl && businessEl.value || '').trim(),
        'Logo File': (uploader.getLogoFilename && uploader.getLogoFilename()) || pf.filename || '',
        'Logo URL': (uploader.getLogoUrl && uploader.getLogoUrl()) || pf.url || '',
        'Design Notes': (notesEl && notesEl.value || '').trim()
      };
    };

    /* Block ATC while an upload is in flight. Capture-phase +
       stopImmediatePropagation halts the section's AJAX ATC handler too —
       without it the add-on line would land in cart missing the logo URL. */
    form.addEventListener('submit', function(ev) {
      if (yesRadio.checked && uploader.isUploading && uploader.isUploading()) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        if (labelEl) labelEl.textContent = 'Upload still in progress — hang on';
        if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = 'Add to Cart'; }
      }
    }, true);

    /* ?logo=1 deep link — lineup tiles on /pages/custom-branding and the
       redirects from the retired standalone Custom Branded products land
       here with branding intent: open the row, preselect the wrap.
       Deferred to DOMContentLoaded: the section's accordion + radio-state
       listeners (initStack) attach there, and head.click()/the change
       event are no-ops before that. */
    function applyLogoDeepLink() {
      if (!/[?&]logo=1(&|$)/.test(window.location.search)) return;
      var row = document.querySelector('[data-logo-addon]');
      var head = row && row.querySelector('.kc-stack__head, .kc-pdp2__ahead');
      yesRadio.checked = true;
      yesRadio.dispatchEvent(new Event('change', { bubbles: true }));
      if (head && head.getAttribute('aria-expanded') !== 'true') head.click();
      if (row) {
        setTimeout(function() { row.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 250);
      }
      // Proposal customers (?ref=<slug>) already gave us their logo when we built
      // their mockup — it rides to the order via the _deal_slug line property, so
      // there is nothing to upload. Swap the empty-upload prompt for reassurance.
      if (/[?&]ref=/.test(window.location.search)) {
        var fromProposal = document.getElementById('kc-logo-from-proposal');
        var noAssets = document.getElementById('kc-logo-noassets');
        if (fromProposal) fromProposal.removeAttribute('hidden');
        if (noAssets) noAssets.setAttribute('hidden', '');
        // Prefill brand, the chosen-design mockup thumb, and the logo URL we
        // already hold (public URLs on the order link). kcLogoAddonProps reads
        // kcProposalPrefill so the logo rides the wrap line; all stay editable.
        try {
          var pq = new URLSearchParams(window.location.search);
          var pBrand = pq.get('brand');
          var pLogo = pq.get('logo_url');
          var pMock = pq.get('mockup');
          if (pBrand && businessEl && !businessEl.value) businessEl.value = pBrand;
          if (pLogo) {
            var pName = ((pLogo.split('?')[0].split('/').pop()) || 'logo');
            window.kcProposalPrefill = { url: pLogo, filename: pName };
          }
          var mockWrap = document.getElementById('kc-proposal-mockup-wrap');
          var mockImg = document.getElementById('kc-proposal-mockup');
          if (pMock && mockWrap && mockImg) { mockImg.src = pMock; mockWrap.removeAttribute('hidden'); }
        } catch (e) { /* URLSearchParams unsupported — reassurance banner still shows */ }
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyLogoDeepLink);
    } else {
      applyLogoDeepLink();
    }
  })();

})();
